// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/icon_best.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/icon_best2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/icon_best3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/icon_info.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/icon_like_darknavy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/icon_arrow_small.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/icon_arrow_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/icon_arrow_line.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/icon_arrow_line2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/icon_pen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/icon_pen_primary.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/icon_delete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/icon_picture.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/icon_setting.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/icon_setting_primary.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../img/icon_delete_primary.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/icon_error.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../img/icon_search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/icon_arrow_gray30.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/icon_date.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../img/icon_view.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../img/icon_like.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../img/icon_thumb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/icon_topstar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../img/icon_tag.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../img/icon_arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../img/icon_file.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../img/icon_delete_gray20.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../img/icon_like_gray00.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../img/icon_pen_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../img/icon_answer_arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../img/icon_answer_arrow_gray.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../img/icon_move.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../img/icon_arrow_secondary.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../img/bg_banner_my.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../img/icon_logo_ls_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../img/coverbg_banner_my_m.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../img/icon_arrow_bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../img/bg_loginok.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/********************************************* Community *********************************************/
/* root */
:root {
  /* 컬러 */
  --primary: #0a78ff;
  --primary-hover: #0050b8;
  --primary-active: #003876;
  --secondary: #2a2c2f;
  --secondary-hover: #142c4c;
  --secondary-active: #1f3e68;
  --point-01: #577eff;
  --point-02: #00a985;
  --point-03: #d6a833;
  --point-04: #c70060;
  --point-05: #2c364e;
  --point-06: #005b09;
  --point-01-bg: #f2f5fb;
  --point-02-bg: #ebf9f6;
  --point-03-bg: #fffff7;
  --point-04-bg: #fff6f7;
  --point-05-bg: #f8f9fb;
  --point-06-bg: #f8fff6;
  --dark-red: #900d19;
  --red: #ff0000;
  --sky: #e7f2ff;
  --dark-green: #006a65;
  --navy: #051c3f;
  --dark-navy: #0a1e5a;
  --gray-90: #101a2d;
  --gray-80: #26282e;
  --gray-70: #2a2c2f;
  --gray-60: #2c364e;
  --gray-50: #576274;
  --gray-40: #646c74;
  --gray-30: #7783a1;
  --gray-20: #909fb7;
  --gray-10: #dde2e9;
  --gray-05: #f2f5fb;
  --gray-00: #fff;

  --border: #dde2e9;
  --placeholder: #909fb7;
  --input-hover: #e6f0ff;
  --input-select: #b4d2ff;

  --shadow-01: 0px 2px 10px 0px rgba(67, 85, 131, 0.07);
  --shadow-02: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);
  --shadow-03: 0px 2px 10px 0px rgba(67, 85, 131, 0.5);
  --shadow-04: 0px 4px 10px 0px rgba(122, 133, 150, 0.5);
  --shadow-05: 0px 1px 4px 0px rgba(67, 85, 131, 0.25);
  --shadow-06: 0px 2px 7px 0px rgba(67, 85, 131, 0.5);
  --shadow-07: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);

  --gradation-01: linear-gradient(180deg, #f7f8fa 0%, rgba(247, 248, 250, 0) 100%);
}
.bg-primary {
  background: var(--primary) !important;
}
.primary {
  color: var(--primary) !important;
}
.red {
  color: var(--red) !important;
}
.navy,
.btn-txt span.navy {
  color: var(--navy) !important;
}
.bg-gray60 {
  background: var(--gray-60) !important;
}
.point-01-bg {
  background: var(--point-01-bg) !important;
}
.gray30,
.btn-txt span.gray30 {
  color: var(--gray-30) !important;
}
.shadow-1 {
  box-shadow: var(--shadow-02);
}
.shadow-2 {
  box-shadow: var(--shadow-02);
}
.shadow-3 {
  box-shadow: var(--shadow-02);
}
.shadow-4 {
  box-shadow: var(--shadow-02);
}
.shadow-5 {
  box-shadow: var(--shadow-02);
}
.shadow-6 {
  box-shadow: var(--shadow-02);
}

.border-1 {
  border: 1px solid var(--border);
}

/* border-radius */
.b-radius0 {
  border-radius: 0 !important;
}
.b-radius2 {
  border-radius: 2px !important;
}
.b-radius4 {
  border-radius: 4px !important;
}

/* icon */
i {
  display: block;
  width: 16px;
  height: 16px;
  flex: none;
}
i.w20 {
  width: 20px;
  height: 20px;
}
i.w24 {
  width: 24px;
  height: 24px;
}
.icon-best {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: 100%;
}
.icon-best2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  background-size: 100%;
}
.icon-best3 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
  background-size: 100%;
}
.icon-info {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
  background-size: 100%;
}
.icon-like {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center;
  background-size: 100%;
}
.icon-arrow-small {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center center;
  background-size: 100%;
}
.icon-arrow-large {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center;
  background-size: 100%;
}
.icon-arrow-large-next {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center;
  background-size: 100%;
  transform: rotate(-90deg);
}
.icon-arrow-line {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center center;
  background-size: 100%;
}
.icon-arrow-line2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center center;
  background-size: 100%;
}
.icon-pen {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center center;
  background-size: 100%;
}
i.icon-pen:hover,
i.icon-pen:active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center center;
}
.icon-delete {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center center;
  background-size: 100%;
}
.icon-picture {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center center;
  background-size: 100%;
}
.icon-setting {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center center;
  background-size: 100%;
}
.icon-setting-primary {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center;
  background-size: 100%;
}

/* button */
button.xlarge {
  height: 48px !important;
}
button.large {
  height: 42px !important;
}
button.medium {
  height: 32px !important;
}
button.small {
  height: 28px !important;
}
button.xlarge span {
  font-size: 16px !important;
}
button.large span {
  font-size: 16px !important;
}
button.medium span {
  font-size: 16px !important;
}
button.small span {
  font-size: 14px !important;
}
button[class*='-ico'] {
  border: 0;
  width: 20px;
  height: 20px;
  background-size: 100%;
}
button[class*='-line'] {
  border: 1px solid var(--border);
  padding: 0 24px;
  height: 32px;
}
button[class*='-txt'] {
  border: 0;
  padding: 0;
  gap: 4px;
  height: auto !important;
}
button[class*='-txt'] span {
  color: var(--primary);
  font-weight: 400;
}
button[class*='-txt']:hover span,
button[class*='-txt']:active span {
  font-weight: 500;
}
button[class*='-txt'].medium span {
  font-size: 14px !important;
}
button[class*='-line'] span {
  color: var(--dark-navy);
  font-size: 16px;
}
button[class*='-line']:hover,
button[class*='-line']:active {
  background: var(--primary);
  border-color: var(--primary);
}
button[class*='-line']:hover span,
button[class*='-line']:active span {
  color: var(--gray-00);
}
.community .btn-area {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.btn-basic.bg-gray60 {
  border-color: var(--gray-60) !important;
}
@media screen and (max-width: 732px) {
  button.xlarge {
    height: 32px !important;
  }
  button.xlarge span {
    font-size: 14px !important;
  }
  button.large {
    height: 32px !important;
  }
  button.large span {
    font-size: 14px !important;
  }
}

/* scrollbar */
.community *::-webkit-scrollbar,
.community *::-webkit-scrollbar,
.community *::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
.community *::-webkit-scrollbar-thumb,
.community *::-webkit-scrollbar-thumb,
.community *::-webkit-scrollbar-thumb {
  background-color: var(--gray-20);
  border: 3px solid transparent;
}

/* etc */
.community .popup-etc {
  top: 24px;
  right: 0;
  width: max-content;
  box-shadow: var(--shadow-04);
  filter: none;
}
.community .popup-etc li {
  padding: 2px 0;
}
.community .popup-etc li:first-child {
  padding-bottom: 0;
}
.community .popup-etc li:last-child {
  padding-top: 0;
}
.community .popup-etc li button {
  /* width: auto !important; */
  height: auto !important;
  border: 0 !important;
  background-size: 24px !important;
  background-position: 12px center !important;
  padding: 3px 16px 2px 45px !important;
  border-radius: 0;
  justify-content: flex-start;
}
.community .popup-etc li button.btn-edit-g {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center center;
}
.community .popup-etc li button.btn-delete-gr {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center center;
}
.community .popup-etc li button:focus {
  background-color: #e6f0ff;
}
.community .popup-etc li button.btn-edit-g:focus,
.community .popup-etc li button.btn-edit-g:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center;
}
.community .popup-etc li button.btn-delete-gr:focus,
.community .popup-etc li button.btn-delete-gr:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center;
}
.community .popup-etc li button:focus span,
.community .popup-etc li button:hover span {
  font-weight: 700;
  color: #19181a;
}
.community .popup-etc li button:focus {
  background-color: #e6f0ff !important;
  border-radius: 0;
}
.community .popup-etc li button:hover {
  background-color: #e6f0ff !important;
  border-radius: 0;
}
#wrap.page-market.community .btn-login:hover,
#wrap.page-market.community .btn-login:active {
  background: #0050b8;
}
#wrap.page-market.community .btn-login:active {
  border-color: #003876;
  background-color: #003876;
}

/* etc - 블라인드 내글 관련 */
.txt-info.blind {
  display: flex;
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #f55547 !important;
}
.txt-info.blind:before {
  content: '';
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat center -1px;
  background-size: 100%;
  flex: none;
}
.community .area-result .item-list.view > li .item-info-top .txt-info.blind {
  margin-top: -12px;
}
@media screen and (max-width: 499px) {
  .community .area-result .item-list.view > li .item-info-top .txt-info.blind {
    margin-bottom: 4px;
  }
}

/* Community - main */
#wrap.page-market.community {
  overflow-x: unset;
}
#wrap.page-market.community > .container .content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  background: #fff;
  padding: 0 40px;
  width: calc(100% - 80px);
  max-width: 1530px;
  margin: 0 auto 160px;
}
#wrap.page-market.community > .container .content .content-center {
  flex: 1;
  width: calc(100% - 400px);
}
/* Community - main - 검색영역 */
#wrap.page-market.community > .container .content .area-search h2 {
  font-size: 36px;
  letter-spacing: -0.035em;
  color: var(--secondary);
}
#wrap.page-market.community > .container .content .area-search .searcharea {
  margin: 30px auto 0;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-01);
}
#wrap.page-market.community > .container .content .area-search .searcharea .searchinput {
  width: calc(100% - 40px);
}
#wrap.page-market.community > .container .content .area-search .searcharea button.btn-search {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat center center;
}
#wrap.page-market.community > .container .content .area-search .searcharea .select.active ul {
  margin: 2px 0 0 -32px;
  padding: 2px 0;
  border-radius: 8px;
}
#wrap.page-market.community > .container .content .area-search .searcharea .select.active ul li:active {
  font-weight: 500;
}

/* Community - main - 리스트영역 */
.community .area-result {
  /* max-width: 1082px; */
  max-width: unset;
}
.community .solution-area {
  margin-top: 0;
}
.area-result .item-list {
  grid-template-columns: repeat(auto-fill, minmax(350px, auto));
  gap: 16px;
}
.community .solution-area .item-list-top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}
.community .solution-area .item-list-top .left,
.community .solution-area .item-list-top .right {
  display: flex;
  gap: 24px;
}
.community .solution-area .item-list-top .left + .right {
  width: auto;
}
.community .solution-area .item-list-top .right {
  position: relative;
  width: 100%;
  justify-content: flex-end;
}
.community .area-result .solution-area .item-list-top .select {
  font-size: 0.813rem;
  color: var(--gray-30);
}
.community .area-result .solution-area .item-list-top .select .selected {
  gap: 8px;
}
.community .area-result .solution-area .item-list-top .select .selected .arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat center center;
  background-size: 100%;
}
.community .area-result .solution-area .item-list-top .select.active .selected .arrow {
  transform: rotate(180deg);
}

.community .area-result .solution-area .item-list-top .select.active ul {
  margin-top: 8px;
  border: 0;
  border-radius: 8px;
  min-width: 128px;
  width: auto !important;
}
.community .area-result .solution-area .item-list-top .select ul li {
  color: var(--secondary);
}
.community .area-result .solution-area .item-list-top .select ul li:active {
  font-weight: 500;
}
.community .solution-area .top .btn-basic {
  border-color: var(--primary) !important;
  background-color: var(--primary) !important;
}
.community .solution-area .top .btn-basic span {
  color: var(--gray-00);
}
.community .solution-area .top .btn-basic:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}
.community .solution-area .top .btn-basic:active {
  background-color: var(--primary-active) !important;
  border-color: var(--primary-active) !important;
}
.community .solution-area .top button.large {
  min-width: 140px;
}
.community .area-result .item-list {
  width: calc(100% - 20px);
  grid-template-columns: repeat(3, 1fr);
  /* grid-template-columns: repeat(auto-fill, minmax(331px, auto)); */
  gap: 16px;
}
.community .area-result .item-list > li {
  height: 360px;
  box-shadow: var(--shadow-02);
  border: 0;
  max-width: 350px;
}
.community .area-result .item-list > li .item-info {
  position: relative;
}
.community .area-result .item-list > li .item-info:hover::before,
.community .area-result .item-list > li .item-info:active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #909fb7;
  border-radius: 8px;
}
.community .area-result .item-list > li.set-blue .item-info:hover::before,
.community .area-result .item-list > li.set-blue .item-info:active::before {
  border-color: var(--point-01);
}
.community .area-result .item-list > li.set-teal .item-info:hover::before,
.community .area-result .item-list > li.set-teal .item-info:active::before {
  border-color: var(--point-02);
}
.community .area-result .item-list > li.set-yellow .item-info:hover::before,
.community .area-result .item-list > li.set-yellow .item-info:active::before {
  border-color: var(--point-03);
}
.community .area-result .item-list > li.set-magenta .item-info:hover::before,
.community .area-result .item-list > li.set-magenta .item-info:active::before {
  border-color: var(--point-04);
}
.community .area-result .item-list > li.set-navy .item-info:hover::before,
.community .area-result .item-list > li.set-navy .item-info:active::before {
  border-color: var(--point-05);
}
.community .area-result .item-list > li.set-green .item-info:hover::before,
.community .area-result .item-list > li.set-green .item-info:active::before {
  border-color: var(--point-06);
}
.community .area-result .item-list > li .item-info:hover,
.community .area-result .item-list > li .item-info:active {
  background: #ffffff;
}
.community .area-result .item-list > li.set-blue .item-info:hover,
.community .area-result .item-list > li.set-blue .item-info:active {
  background: #f9fafd;
}
.community .area-result .item-list > li.set-teal .item-info:hover,
.community .area-result .item-list > li.set-teal .item-info:active {
  background: #f9fffe;
}
.community .area-result .item-list > li.set-yellow .item-info:hover,
.community .area-result .item-list > li.set-yellow .item-info:active {
  background: #fffffc;
}
.community .area-result .item-list > li.set-magenta .item-info:hover,
.community .area-result .item-list > li.set-magenta .item-info:active {
  background: #fffbfc;
}
.community .area-result .item-list > li.set-navy .item-info:hover,
.community .area-result .item-list > li.set-navy .item-info:active {
  background: #ffffff;
}
.community .area-result .item-list > li.set-green .item-info:hover,
.community .area-result .item-list > li.set-green .item-info:active {
  background: #fcfffb;
}
.community .area-result .item-list > li .item-info {
  position: relative;
  display: block;
  height: calc(100% - 48px);
  padding: 24px;
}
.community .area-result .item-list > li .item-info-top {
  display: block;
  margin-top: 24px;
  padding: 0;
  overflow: unset;
}
.community .area-result .item-list > li .item-info-top .cate {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  padding: 6px 16px 5px;
  border-radius: 4px 0 4px 0;
  background: #909fb7;
  width: auto;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  line-height: 1.1;
}
.community .area-result .item-list > li {
  background: #f1f3f6;
}
.community .area-result .item-list > li.set-blue {
  background: var(--point-01-bg);
}
.community .area-result .item-list > li.set-teal {
  background: var(--point-02-bg);
}
.community .area-result .item-list > li.set-yellow {
  background: var(--point-03-bg);
}
.community .area-result .item-list > li.set-magenta {
  background: var(--point-04-bg);
}
.community .area-result .item-list > li.set-navy {
  background: var(--point-05-bg);
}
.community .area-result .item-list > li.set-green {
  background: var(--point-06-bg);
}
.community .area-result .item-list > li.set-blue .item-info-top .cate {
  background: var(--point-01);
}
.community .area-result .item-list > li.set-teal .item-info-top .cate {
  background: var(--point-02);
}
.community .area-result .item-list > li.set-yellow .item-info-top .cate {
  background: var(--point-03);
}
.community .area-result .item-list > li.set-magenta .item-info-top .cate {
  background: var(--point-04);
}
.community .area-result .item-list > li.set-navy .item-info-top .cate {
  background: var(--point-05);
}
.community .area-result .item-list > li.set-green .item-info-top .cate {
  background: var(--point-06);
}
.community .area-result .item-list > li .item-info-top .icon-area {
  position: absolute;
  top: 16px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.community .area-result .item-list > li .item-info-top i {
  width: 32px;
  height: 32px;
}
.community .area-result .item-list > li .item-info-top .keyword {
  width: 100%;
  height: 19.5px;
  margin-bottom: 8px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--primary);
  z-index: 1;
  position: relative;
}
.community .area-result .item-list > li .item-info-top .keyword span {
  cursor: pointer;
}
.community .area-result .item-list > li .item-info-top .keyword span:hover {
  font-weight: 500;
}
.community .area-result .item-list > li .item-info-top .keyword span + span {
  margin-left: 16px;
}
.community .area-result .item-list > li .item-info-cont {
  min-height: 62%;
}
.community .area-result .item-list > li .item-info-cont .tit {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--gray-90);
  line-height: 1.4;
  height: 56px;
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
}
.community .area-result .item-list:not(.view) > li .item-info-cont .cont {
  font-size: 0.813rem;
  color: var(--secondary);
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  word-break: break-all;
  word-wrap: break-word;
}
.community .area-result .item-list > li .item-info-bottom {
  position: absolute;
  bottom: 24px;
  display: flex;
  width: calc(100% - 48px);
  gap: 8px;
  z-index: 1;
}
.community .area-result .item-list > li .user-photo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.community .area-result .item-list > li .user-photo > span {
  font-size: 1.5rem;
  color: #fff;
  font-weight: 500;
  text-transform: uppercase;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gray-20);
  border-radius: 50%;
}
.community .area-result .item-list > li .user-photo img {
  border-radius: 50%;
  height: 100%;
  object-fit: cover;
}
.community .area-result .item-list > li .user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}
.community .area-result .item-list > li .name {
  display: flex;
  gap: 4px;
  font-size: 0.813rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--secondary);
}
.community .area-result .item-list > li .etc {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.community .area-result .item-list > li .etc > li {
  display: flex;
  align-items: center;
  gap: 8px;
}
.community .area-result .item-list > li .etc > li span {
  font-size: 0.75rem;
  color: var(--gray-30);
  background-size: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.community .area-result .item-list > li .etc > li span:before {
  content: '';
  width: 16px;
  height: 16px;
}
.community .area-result .item-list > li .etc > li span.date:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat center center;
  background-size: 100%;
}
.community .area-result .item-list > li .etc > li span.view:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat center center;
  background-size: 100%;
}
.community .area-result .item-list > li .etc > li span.like:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat center center;
  background-size: 100%;
}

/* Community - main - floating */
.community .content-left-float {
  position: relative;
  width: 184px;
  z-index: 2;
}
.community .content-right-float {
  position: relative;
  width: 184px;
  z-index: 2;
}
.community .content-left-float .inner,
.community .content-right-float .inner {
  position: absolute;
  top: 335px;
  width: 184px;
}
.community .float-box {
  position: relative;
  padding: 24px 16px;
  background: var(--gray-00);
  border: 1px solid var(--border);
  border-radius: 8px;
}
.community .float-box:not(.banner):hover {
  box-shadow: var(--shadow-02);
  border-radius: 8px;
}
.community .float-box-wrap:hover {
  box-shadow: var(--shadow-02);
  border-radius: 8px;
}
.community .float-box-wrap:hover .float-box:hover {
  box-shadow: none;
  border-radius: none;
}
.community .float-box-wrap .float-box {
  border-radius: 0;
}
.community .float-box-wrap .float-box:first-child {
  border-radius: 8px 8px 0 0;
}
.community .float-box-wrap .float-box:last-child {
  border-radius: 0 0 8px 8px;
}
.community .float-box-wrap .float-box + .float-box {
  border-top: 0;
}
.community .float-box > .icon-info {
  position: absolute;
  top: 22px;
  right: 16px;
  display: none;
}
.community .float-box:hover > .icon-info {
  display: block;
}
.community .float-box > .tit {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--gray-30);
  line-height: 1.5;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.community .float-box > .tit::before {
  content: '';
  width: 16px;
  height: 16px;
}
.community .float-box.best > .tit::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-size: 100%;
}
.community .float-box.topwriter > .tit::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-size: 100%;
}
.community .float-box.tag > .tit::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: 100%;
}
.community .float-box .list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.community .float-box .list > li > a {
  display: flex;
  align-items: center;
  gap: 4px;
}
.community .float-box .list > li > a p {
  font-size: 0.75rem;
  color: var(--secondary);
}
.community .float-box .list > li > a:hover p {
  font-weight: 700 !important;
}
.community .float-box .list > li > a .num {
  color: var(--gray-30);
}
.community .float-box .list > li > a .tit {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}
.community .float-box .list > li > a .like-num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.688rem;
  font-weight: 500;
  color: var(--gray-30);
  width: 32px;
  min-width: 32px;
  height: 16px;
  background: #f0f2f4;
  border-radius: 25px;
}
.community .float-box.tag .list {
  gap: 8px;
}
.community .float-box .list > li > a .tit.keyword {
  padding: 4px 8px 3px;
  background: var(--sky);
  border-radius: 25px;
  flex: none;
  line-height: normal;
  color: var(--primary);
}

.community .float-box .page {
  margin-top: 40px;
  margin-bottom: -8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.community .float-box .page p {
  font-size: 0.75rem;
  color: var(--secondary);
  font-weight: 500;
}
.community .float-box .page a {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat center center;
  background-size: 100%;
}
.community .float-box .page a.btn-next {
  transform: scaleX(-1);
}
.community .float-box.banner {
  margin-bottom: 20px;
  padding: 0;
  border: 0;
  background: none;
  border-radius: 0;
}
.community .float-box.banner .banner-list {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  width: 184px;
  height: 250px;
  border: 1px solid var(--gray-00);
  border-radius: 8px;
}
.community .float-box.banner .banner-list > li {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
}
.community .float-box.banner .banner-list img {
  border-radius: 8px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.community .float-box.banner .slide-pagenation {
  gap: 12px;
  margin-top: 9px;
}

@media screen and (max-width: 1562px) {
  #wrap.page-market.community > .container .content {
    gap: 16px;
  }
  .community .area-result .item-list {
    /* grid-template-columns: repeat(auto-fill, minmax(386.5px, auto)); */
    grid-template-columns: repeat(2, 49.2%);
  }
  .community .area-result .item-list > li {
    max-width: 100%;
  }
}
@media screen and (max-width: 1278px) {
  #wrap.page-market.community > .container {
    min-height: calc(100vh - 101px);
  }
  .community .area-result .item-list {
    grid-template-columns: 100%;
    max-width: 694px;
    /* width: calc(100% - 20px); */
  }
  /* .community .area-result .item-list > li {
    max-width: calc(100% - 20px);
  } */
  .community .content-right-float,
  .community .content-left-float {
    display: none;
  }
  .community .solution-area {
    max-width: 692px;
    margin: 0 auto;
  }
  #wrap.page-market.community > .container .content .area-search .searcharea {
    width: calc(100% - 54px);
    max-width: 634px;
  }
  #wrap.page-market.community > .container .content {
    padding: 0 20px;
    width: calc(100% - 40px);
  }
}
@media screen and (max-width: 733px) {
  #wrap.page-market.community > .container .content .area-search h2 {
    font-size: 2rem;
    text-align: left;
    width: 100%;
  }
  #wrap.page-market.community > .container .content .area-search .searcharea {
    margin-top: 46px;
  }
  #wrap.page-market > .container .content .area-search {
    margin-bottom: 24px;
  }
  .community .solution-area .top button.large.m-mt-26 {
    margin-top: 0 !important;
  }
}
@media screen and (max-width: 732px) {
  .community .area-result .item-list > li {
    height: 306px;
  }
  #wrap.page-market.community > .container .content .content-center {
    width: 100%;
  }
}
@media screen and (max-width: 390px) {
  .community .solution-area .item-list-top .left,
  .community .solution-area .item-list-top .right {
    gap: 10px;
  }
}
@media screen and (max-width: 320px) {
  .community .solution-area .item-list-top {
    gap: 10px;
    flex-wrap: wrap;
  }
}

/* Community - detail */
#wrap.page-market.community.detail > .container {
  background: var(--gradation-01);
}
#wrap.page-market.community.detail > .container .content {
  margin-top: 80px;
  border-top: 0;
  max-width: 1230px;
  background: transparent;
}

/* Community - detail - 댓글뷰 상세화면 */
#wrap.page-market.community.detail > .container.set-no {
  background: #f1f3f6;
}
#wrap.page-market.community.detail > .container.set-blue {
  background: var(--point-01-bg);
}
#wrap.page-market.community.detail > .container.set-teal {
  background: #f9fffe;
}
#wrap.page-market.community.detail > .container.set-yellow {
  background: #fffffc;
}
#wrap.page-market.community.detail > .container.set-magenta {
  background: #fffbfc;
}
#wrap.page-market.community.detail > .container.set-navy {
  background: var(--point-05-bg);
}
#wrap.page-market.community.detail > .container.set-green {
  background: #fcfffb;
}
.community.detail .area-result .item-list.view {
  grid-template-columns: repeat(auto-fill, minmax(100%, auto));
  width: auto !important;
}
.community.detail .area-result .item-list.view > li {
  max-width: 100%;
  height: auto;
  background: var(--gray-00) !important;
}
.community .area-result .item-list.view > li a:hover,
.community .area-result .item-list.view > li a:active {
  background: none !important;
}
.community .area-result .item-list.view > li a:hover::before,
.community .area-result .item-list.view > li a:active::before {
  content: none !important;
}
.community .area-result .item-list.view > li .item-info:hover,
.community .area-result .item-list.view > li .item-info:active {
  background: none !important;
}
.community .area-result .item-list.view > li .item-info:hover::before,
.community .area-result .item-list.view > li .item-info:active::before {
  content: none !important;
}
.community .area-result .item-list.view > li .item-info {
  padding: 0;
  height: auto;
  border-radius: 8px;
}
.community .area-result .item-list.view > li .item-info-top {
  margin-top: 0;
  padding: 40px 32px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-bottom: 1px solid var(--border);
}
.community .area-result .item-list.view .item-info-top .tit {
  font-size: 1.625rem;
  font-weight: 700;
  color: var(--gray-90);
  line-height: 1.5;
  letter-spacing: -0.04em;
  padding: 0;
}
.community .area-result .item-list.view > li .item-info-top .icon-area {
  position: relative;
  top: unset;
  right: unset;
}
.community .area-result .item-list.view > li .item-info-top i {
  width: 40px;
  height: 40px;
}
.area-result .solution-area .item-list.view .top {
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 0;
}
.area-result .solution-area .item-list.view .top .left {
  flex: 1;
  display: flex;
  align-items: flex-start;
}
.area-result .solution-area .item-list.view .top .right {
  position: relative;
}
.area-result .solution-area .item-list.view .btn.btn-etc {
  width: 24px;
  height: 24px;
}
.area-result .solution-area .item-list.view .bottom {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
}
.area-result .solution-area .item-list.view .bottom .left {
  display: flex;
  gap: 8px;
}
.area-result .solution-area .item-list.view .item-info-cont {
  padding: 16px 32px 80px;
}
.area-result .solution-area .item-list.view .item-info-cont > * + * {
  margin-top: 24px;
}
.area-result .solution-area .item-list.view .item-info-cont .keyword {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.area-result .solution-area .item-list.view .item-info-cont .keyword span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: var(--primary);
  line-height: 1.42;
  background: var(--sky);
  padding: 0 12px;
  height: 28px;
  border-radius: 25px;
  cursor: pointer;
}
.area-result .solution-area .item-list.view .item-info-cont .keyword span:hover {
  background: var(--primary);
  color: var(--gray-00);
}
.area-result .solution-area .item-list.view .item-info-cont .keyword span:before {
  content: '#';
}
.area-result .solution-area .item-list.view .item-info-cont .cont {
  font-size: 0.875rem;
  line-height: 1.7;
}
.item-list.view .item-info-cont .cont > * + * {
  margin-top: 24px;
}
.item-list.view li .img-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  height: auto;
  background: none;
  border-radius: 0;
}
.item-list.view li .img-wrap img {
  object-fit: cover;
  border-radius: 0;
  height: 248px;
  width: auto;
}
.area-result .solution-area .item-list.view .item-info-cont > .filelist-wrap {
  margin-top: 56px;
}
.community .area-result .item-list > li .item-info-cont .filelist-wrap .tit {
  font-size: 0.875rem;
  line-height: 1.4;
  font-weight: 700;
  height: auto;
  margin-bottom: 8px;
}
.community .filelist {
  margin: 0;
}
.community .filelist li {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
}
.community .item-list.view .filelist li {
  margin-left: 24px;
}
.community .filelist li span {
  font-size: 14px;
  line-height: 20px;
  background: none;
  padding-left: 0;
  position: relative;
}
.community .filelist li span:before {
  content: '';
  position: absolute;
  left: -24px;
  top: 0;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat center center;
  background-size: 100%;
}
.community .filelist li .btn-delete {
  display: inline;
  width: 20px;
  height: 20px;
  margin-left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat center 1px;
  background-size: 100%;
}
.community .area-result .item-list.view > li {
  box-shadow: var(--shadow-06);
}
.community .area-result .item-list.view > li .item-info-bottom {
  position: relative;
  bottom: unset;
  padding: 0 32px 32px;
  width: calc(100% - 64px);
}
.community .area-result .item-list.view > li .item-info-bottom .btn-area {
  justify-content: flex-end;
}
.community .area-result .item-list.view > li .btn-line.toggle {
  gap: 8px;
  padding: 0;
  width: 94px;
}
.community .area-result .item-list.view > li .btn-line.toggle.large {
  height: 40px !important;
}
.community .area-result .item-list.view > li .btn-line.toggle span {
  color: var(--dark-navy);
  font-size: 16px !important;
}
.community .area-result .item-list.view > li .btn-line.toggle span.num {
  font-weight: 400;
  min-width: 24px;
}
.community .area-result .item-list.view > li .btn-line.toggle .icon-like {
  width: 18px;
  height: 18px;
}
.community .area-result .item-list.view > li .btn-line.toggle:hover,
.community .area-result .item-list.view > li .btn-line.toggle:active,
.community .area-result .item-list.view > li .btn-line.toggle.active {
  background: var(--primary);
  border-color: var(--primary);
}
.community .area-result .item-list.view > li .btn-line.toggle:hover span,
.community .area-result .item-list.view > li .btn-line.toggle:active span,
.community .area-result .item-list.view > li .btn-line.toggle.active span {
  color: var(--gray-00);
}
.community .area-result .item-list.view > li .btn-line.toggle:hover .icon-like,
.community .area-result .item-list.view > li .btn-line.toggle:active .icon-like,
.community .area-result .item-list.view > li .btn-line.toggle.active .icon-like {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat center center;
  background-size: 100%;
}

/* Community - detail - 댓글 리스트 */
.comment-area {
  margin-top: 90px;
}
.community .solution-area .comment-area .item-list-top {
  margin-bottom: 2px;
}
.m-m10 .item-list-top,
.community .solution-area .m-m10 .item-list-top {
  margin: 0 10px;
  width: calc(100% - 20px);
}
.community .solution-area .comment-area .item-list-top .num {
  font-size: 0.875rem;
  line-height: 1.7;
  color: var(--secondary);
}
.community .solution-area .comment-area .item-list-top .num span {
  margin-left: 8px;
}
.community .area-result .comment-area .item-list {
  gap: 8px;
}
.community .area-result .comment-area .item-list > li:not(.best) {
  box-shadow: var(--shadow-05);
}
.community .area-result .comment-area .item-list.view > li .item-info-top {
  padding: 24px 32px 0;
  border-bottom: 0;
}
.area-result .solution-area .comment-area .item-list.view > li .item-info-top .bottom {
  align-items: flex-start;
}
.community .area-result .comment-area .item-list.view > li .item-info-cont {
  padding: 16px 32px 24px 80px;
  display: flex;
  justify-content: space-between;
  gap: 32px;
}
.community .area-result .comment-area .item-list.view > li .item-info-cont .left {
  flex: 1;
}
.area-result .solution-area .comment-area .item-list.view .item-info-cont .cont {
  line-height: 1.35;
}
.area-result .solution-area .comment-area .item-list.view .item-info-cont > * + * {
  margin-top: 0;
}
.community .area-result .comment-area .item-list.view > li .item-info-top .icon-area + .user-photo {
  margin-left: -8px;
}
.community .area-result .comment-area .item-list.view > li .btn-line.toggle {
  width: 62px;
}
.community .area-result .comment-area .item-list.view > li .btn-line.toggle span {
  font-size: 12px !important;
}
.community .area-result .comment-area .item-list.view > li .btn-line.toggle span.num {
  min-width: 14px;
}
.comment-area .list-more {
  margin: 22px auto 0;
  padding-bottom: 6px;
}
.comment-area .list-more .icon-arrow-small {
  width: 17px;
}
.comment-area .filelist-wrap,
.comment-area .filelist {
  margin-top: 16px;
}

/* Community - detail - 댓글 작성 */
.community .comment-write-area {
  margin: 16px 0 0;
}
.m-m10 .comment-write-area {
  margin: 16px 10px 10px;
}
.comment-write-area .info-txt-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  min-height: 200px;
  font-size: 0.875rem;
  text-align: center;
  line-height: 1.7;
  color: var(--secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--gray-00);
}
.comment-write-area .info-txt-box strong {
  font-weight: 500;
}
.community .page-bottom {
  margin-top: 80px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
}
.community .m-m10 .page-bottom {
  margin: 80px 10px 10px;
}
.write-box .top,
.area-result .solution-area .write-box .top {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 0;
}
.write-box .top + .filelist,
.write-box .top + .filelist-wrap {
  margin-top: 16px;
}
.community .write-box .filelist {
  margin-left: 24px;
}
.write-box .top p {
  font-size: 0.875rem;
  line-height: 1.1;
  color: var(--gray-20);
}
.write-box .filearea {
  border-bottom: 1px solid var(--border);
  border-left: 1px solid var(--border);
  border-right: 1px solid var(--border);
  border-radius: 0 0 4px 4px;
  background: var(--gray-00);
  padding: 16px;
}
.write-box .editarea {
  border: 1px solid var(--border);
  border-radius: 4px 4px 0 0;
  background: var(--gray-00);
  padding: 0;
}
.write-box .editarea textarea {
  padding: 16px 16px 0;
  height: 230px;
  border: 0;
  width: calc(100% - 32px);
  font-size: 0.875rem;
  line-height: 1.7;
}
.write-box .editarea .ck-editor__editable:not(td) {
  height: 594px;
}
.community .write-box .btn-area {
  margin-top: 12px;
  justify-content: flex-end;
}
.comment-write-area .write-box:hover .editarea,
.comment-write-area .write-box:active .editarea {
  border-top-color: var(--primary);
  border-left-color: var(--primary);
  border-right-color: var(--primary);
}
.comment-write-area .write-box:hover .filearea,
.comment-write-area .write-box:active .filearea {
  border-bottom-color: var(--primary);
  border-left-color: var(--primary);
  border-right-color: var(--primary);
}

@media screen and (max-width: 1278px) {
  .community.detail .solution-area {
    max-width: 100%;
  }
  #wrap.page-market.community.detail > .container .content {
    padding: 0 40px;
    width: calc(100% - 80px);
    margin-top: 40px;
  }
  #wrap.page-market.community.detail > .container .content > div {
    padding: 0;
    width: 100%;
  }
  .community.detail .area-result .item-list {
    max-width: 100%;
  }
}
@media screen and (max-width: 779px) {
  .area-result .solution-area .item-list.view .top .right {
    width: auto;
  }
}
@media screen and (max-width: 732px) {
  #wrap.page-market.community.detail > .container .content {
    margin-bottom: 74px;
  }
  .community .area-result .item-list.view .item-info-top .tit {
    font-size: 1.5rem;
  }
  .area-result .solution-area .item-list.view .item-info-cont {
    padding: 16px 32px 40px;
  }
  .community .area-result .comment-area .item-list.view > li .item-info-cont {
    padding: 16px 32px 24px;
    flex-direction: column;
    gap: 16px;
  }
  .community .area-result .comment-area .item-list.view > li .item-info-cont .btn-area {
    justify-content: flex-end;
  }
  .comment-write-area .info-txt-box {
    min-height: 182px;
  }
  .community .page-bottom {
    padding-top: 40px;
  }
}
@media screen and (max-width: 499px) {
  #wrap.page-market.community.detail > .container .content {
    padding: 0 20px;
    width: calc(100% - 40px);
  }
  .community.detail .area-result div:not(.comment-area) > .item-list.view {
    margin: -40px -20px -10px;
    padding-right: 0 !important;
    width: calc(100% + 20px) !important;
    max-width: calc(100% + 20px) !important;
  }
  .community.detail .area-result div:not(.comment-area) > .item-list.view > li {
    box-shadow: none;
    border-radius: 0;
    width: 100%;
  }
  .comment-area {
    margin-top: 10px;
  }
  .community .area-result .comment-area .item-list.view > li .item-info-cont {
    padding: 16px 20px 20px;
  }
  .community .area-result .item-list.view > li .item-info-top {
    padding: 40px 20px 16px;
  }
  .area-result .solution-area .item-list.view .top {
    gap: 0;
  }
  .community .area-result .item-list.view .item-info-top .tit {
    line-height: 1.4;
  }
  .area-result .solution-area .item-list.view .item-info-cont {
    padding: 16px 20px 40px;
  }
  .area-result .solution-area .item-list.view .item-info-cont > .filelist-wrap {
    margin-top: 40px;
  }
  .community .area-result .item-list.view > li .item-info-bottom {
    padding: 0 20px 20px;
    width: calc(100% - 40px);
  }
  .community .area-result .comment-area .item-list.view > li .item-info-top {
    padding: 20px 20px 0;
  }
  .m-m10 .item-list-top,
  .community .solution-area .m-m10 .item-list-top {
    align-items: center;
  }
  .m-m10 .comment-write-area,
  .community .comment-write-area {
    margin-top: 8px;
  }
  .comment-area .list-more {
    margin-top: 10px;
  }
  .comment-write-area .info-txt-box {
    min-height: 114px;
    padding: 16px;
  }
  .write-box .editarea textarea {
    height: 160px;
  }
  .write-box .top,
  .area-result .solution-area .write-box .top {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .community .write-box .btn-area {
    margin-top: 8px;
  }
  .write-box .filearea {
    padding: 16px 0 16px 16px;
  }
  .write-box .top + .filelist-wrap {
    max-height: 106px;
    overflow-y: auto;
    padding-right: 10px;
  }
  .community .write-box .filelist {
    padding-right: 8px;
  }
}

/* Community - detail - 글 작성 */
.community .m-m10 .write-area {
  margin: 12px 10px 10px;
}
.community .write-area {
  margin: 12px 0 0;
}
.community.detail .solution-area .m-m10 .page-info {
  margin-left: 10px;
  margin-right: 10px;
}
.community.detail .solution-area .page-info {
  margin-bottom: 12px;
}
.community.detail .solution-area .page-info .tit {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--secondary);
  letter-spacing: -0.04em;
}
.community.detail .solution-area .page-info .tit + .txt {
  margin-top: 16px;
}
.community.detail .solution-area .page-info .txt {
  font-size: 0.813rem;
  line-height: 1.69;
  letter-spacing: -0.04em;
}
.num-bg,
.btn-txt.medium span.num-bg {
  padding: 0 8px;
  min-width: 18px;
  height: 20px;
  background: var(--primary);
  border-radius: 25px;
  font-size: 0.75rem !important;
  font-weight: 500 !important;
  color: var(--gray-00) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.community .write-area .flex-row {
  gap: 34px;
}
.community .write-area .flex-row > .right {
  flex: 1;
}
.community .write-area .flex-row > .left .tit {
  min-width: 122px;
  margin-top: 4px;
  margin-left: 8px;
  font-size: 0.938rem;
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1.3;
  color: var(--secondary);
}
.community .write-area .tagarea {
  border-radius: 4px 4px 0 0;
  background: var(--gray-00);
  padding: 16px;
  height: 128px;
}
.community .write-area .write-box > .shadow-box > div + div {
  border-top: 1px solid var(--border);
}
.community ul.keyword {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.community ul.keyword > li {
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--sky);
  padding: 0 12px;
  height: 28px;
  border-radius: 25px;
  justify-content: center;
}
.community ul.keyword span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: var(--primary);
}
/* .community ul.keyword span:hover {
  background: var(--primary);
  color: var(--gray-00);
} */
.community ul.keyword span:before {
  content: '#';
}
.community ul.keyword li .btn-delete {
  display: inline;
  width: 20px;
  height: 20px;
  margin-left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat center center;
  background-size: 100%;
}
.community .write-area .filearea {
  border: 0;
}
.community .write-box .top + .scrollH {
  padding-right: 14px;
  margin-right: -14px;
}
.community .write-box .filearea .top + .scrollH {
  margin-top: 16px;
  height: 132px;
}
.community .write-box .tagarea .top + .scrollH {
  margin-top: 8px;
  height: 104px;
}
.community .shadow-box {
  border-radius: 4px;
  background: var(--gray-00);
  box-shadow: var(--shadow-02);
}
.community .shadow-box > * {
  padding: 16px;
}
.community .write-area .shadow-box + .shadow-box {
  margin-top: 8px;
}
.community .write-area .write-box .editarea,
.community .shadow-box > .editarea {
  border: 0;
  padding: 0;
}
.write-area .editarea .title-wrap {
  border-bottom: 1px solid var(--border);
  padding: 16px 24px;
}
.input__area.label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.input__area.label .icon-label {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0 8px;
  height: 20px;
  background: var(--primary);
}
.input__area.label input[type='text'] {
  flex: 1;
}
.write-area .editarea .title-wrap label {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 20px;
  line-height: 1.6;
  color: var(--gray-20);
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.write-area .editarea .title-wrap label.star:after {
  font-size: 20px;
  margin-left: 1px;
  line-height: 1.3;
  font-weight: 500;
}
.write-area .editarea .title-wrap .input__area input[type='text']:focus + label,
.write-area .editarea .title-wrap .input__area input[type='text']:valid + label,
.write-area .editarea .editbox-wrap input[type='text']:valid + label {
  display: none;
}
.write-area .editarea .title-wrap input[type='text'] {
  height: 100%;
  width: 100%;
  font-size: 20px;
  line-height: 1.6;
  color: var(--secondary);
  font-weight: 700;
  border: 0;
  padding: 0;
}
.write-area .editarea .editbox-wrap {
  height: 624px;
  border: 0;
  border-radius: 0;
}
.write-area .editarea .editbox-wrap .ck.ck-editor {
  height: 100%;
}
.write-area .editarea .editbox-wrap .ck.ck-editor__main {
  height: calc(100% - 30px);
  border-top: 1px solid #dde2e9;
}
.write-area .editarea .editbox-wrap .ck.ck-editor__main .ck.ck-content.ck-editor__editable {
  height: calc(100% - 16px);
  padding: 16px 24px 0;
  border: 0;
  border-radius: 0 0 4px 4px;
}
.area-result .ck.ck-editor__main h2 {
  font-size: 1.5em;
}
.area-result .ck.ck-editor__main h3 {
  font-size: 1.17em;
}
.area-result .ck.ck-editor__main h2,
.area-result .ck.ck-editor__main h3,
.area-result .ck.ck-editor__main h4 {
  font-weight: bold;
  margin: revert;
  padding: revert;
}
.area-result .ck.ck-editor__main h4,
.area-result .ck.ck-editor__main p,
.area-result .ck.ck-editor__main span {
  font-size: 1em;
}
.write-area .editarea .editbox-wrap .ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {
  box-shadow: none;
}
.write-area .editarea .editbox-wrap .ck.ck-toolbar {
  border: 0;
  height: 30px;
}
.write-area .editarea .editbox-wrap .ck.ck-toolbar > .ck-toolbar__items {
  height: 100% !important;
}
.write-area .editarea .editbox-wrap .ck.ck-toolbar.ck-toolbar_vertical > .ck-toolbar__items {
  width: auto;
  max-width: unset;
}
.area-result .ck i {
  display: unset;

  width: unset;
  height: unset;
}
.area-result .ck dl,
.area-result .ck ol,
.area-result .ck table,
.area-result .ck ul,
.area-result .ck p,
.area-result .ck span {
  margin: 0;
  padding: 0;
}
.area-result .ck.ck-toolbar.ck-toolbar_vertical > .ck-toolbar__items > .ck {
  width: auto;
}

@media screen and (max-width: 1278px) {
  .community.detail .solution-area .m-m10 .page-info {
    margin-top: 10px;
  }
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive).page-market.community .write-box .input__direct {
    height: 32px;
  }
}
@media screen and (max-width: 600px) {
  .community .shadow-box > * {
    padding: 16px 20px;
  }
  .community .write-area .flex-row {
    gap: 16px;
    flex-direction: column !important;
  }
  .community .write-area .flex-row > .left .tit {
    margin: 0;
  }
  .community .input__area .select,
  .community .area-result .solution-area .write-area .top .input__area .select {
    height: 38px;
  }
  .community .area-result .solution-area .write-area .top .input__area .select {
    min-width: 100%;
    width: 100%;
  }
  .community .write-area .tagarea {
    height: 210px;
  }
  .community .area-result .solution-area .write-area .top .input__area .searchinput {
    flex: 1;
  }
  #wrap:not(.no-responsive).page-market.community .write-box .input__direct {
    width: 100%;
    height: 40px;
  }
  .community .area-result .solution-area .write-area .searcharea .input__direct input[type='text'] {
    height: 38px;
  }
  .community .area-result .solution-area .write-area .searcharea .btn-add {
    width: 40px;
    height: 40px;
    background-size: 16px;
  }
  .community .write-box .tagarea .top + .scrollH {
    margin-top: 16px;
    height: 134px;
  }
  .community .write-box .filearea .top + .scrollH {
    height: 128px;
  }
  .community .write-area .write-box .filearea .top {
    gap: 8px;
  }
  .community .write-area .write-box > .btn-area button.large {
    height: 40px !important;
  }
}
@media screen and (max-width: 499px) {
  .community .write-area .write-box > .btn-area {
    flex-wrap: nowrap;
  }
  .community .write-area .write-box > .btn-area button.large {
    padding: 0 20px;
  }
  .write-area .editarea .editbox-wrap .ck.ck-editor__main {
    height: calc(100% - 38px) !important;
  }
}
@media screen and (max-width: 360px) {
  .community .write-area .write-box > .btn-area button.large.w140 {
    flex: 1;
    width: auto !important;
  }
}

/* Community - detail - 마이페이지 */
.community .mypage-area {
  margin-top: -16px;
  min-height: 906px;
  display: flex;
  flex-direction: column;
}
.community .shadow-box > .mypage-top {
  display: flex;
  gap: 52px;
  padding: 40px;
  border-bottom: 1px solid var(--border);
}
.mypage-top > .left {
  display: flex;
  gap: 16px;
}
.mypage-top .user-photo {
  width: 72px;
  height: 72px;
  position: relative;
}
.mypage-top .user-photo > button.btn-profile {
  border: 0;
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 50%;
}
.mypage-top .user-photo > button.btn-profile span {
  font-size: 2.5rem;
  color: #fff;
  font-weight: 500;
  text-transform: uppercase;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gray-20);
  border-radius: 50%;
}
.mypage-top .user-photo > button.btn-profile:not(.non-hover):hover::before,
.mypage-top .user-photo > button.btn-profile:not(.non-hover):active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) no-repeat center center rgba(10, 120, 255, 0.5);
  background-size: 24px;
  border-radius: 50%;
}
.mypage-top .user-photo > button.btn-profile.non-hover,
.mypage-top .user-photo > button.btn-profile:disabled {
  cursor: default;
  border-color: unset !important;
  background-color: unset !important;
}
.mypage-top .user-photo > button.btn-profile img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.mypage-top .user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.mypage-top .user-info > * {
  display: flex;
  align-items: center;
  gap: 4px;
}
.mypage-top .user-info p {
  font-size: 14px;
  font-weight: 500;
}
.mypage-top .user-info .name {
  font-size: 16px;
}
.mypage-top > .right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.mypage-top > .right .tit {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 500;
}
.mypage-top > .right .txt {
  font-size: 14px;
  line-height: 1.6;
}
.mypage-top .btn i {
  width: 24px;
  height: 24px;
}
.community .shadow-box > .mypage-bottom {
  display: flex;
  padding: 0;
  flex: 1;
}
.mypage-bottom > .left {
  width: 205px;
  background: #f7f8fa;
  border-right: 1px solid var(--border);
}
.mypage-bottom > .left .lnb {
  display: flex;
  flex-direction: column;
}
.mypage-bottom > .left .lnb > li {
  height: 46px;
  border-bottom: 1px solid var(--border);
}
.mypage-bottom > .left .lnb > li > a {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 24px;
  font-size: 14px;
  line-height: 1;
  color: var(--secondary);
}
.mypage-bottom > .left .lnb > li.on {
  border-right: 1px solid var(--white);
  width: calc(100% + 1px);
}
.mypage-bottom > .left .lnb > li.on > a {
  color: var(--primary);
  font-weight: 700;
  background: #fff;
}
.mypage-bottom .lnb__toggleBtn {
  display: none;
}
.mypage-bottom > .right {
  flex: 1;
  padding: 8px 16px 16px;
  width: calc(100% - 237px);
}
.area-result .solution-area .mypage-area .mypage-bottom .tab__line {
  height: 39px;
  margin-bottom: 16px;
}
.area-result .solution-area .mypage-area .mypage-bottom .tab__line li {
  font-size: 15px;
  color: var(--gray-40);
  font-weight: 400;
  padding: 0 14px 0 16px !important;
}
.area-result .solution-area .mypage-area .mypage-bottom .tab__line li .num {
  min-width: 25px;
  margin-left: 4px;
  font-weight: 350;
  text-align: center;
  color: var(--gray-20);
}
.area-result .solution-area .mypage-area .mypage-bottom .tab__line li.on,
.area-result .solution-area .mypage-area .mypage-bottom .tab__line li:hover {
  font-weight: 500;
  color: var(--secondary);
}
.area-result .solution-area .mypage-area .mypage-bottom .tab__line li.on .num,
.area-result .solution-area .mypage-area .mypage-bottom .tab__line li:hover .num {
  color: var(--primary);
}
.area-result .solution-area .mypage-area .mypage-bottom .tab__line li.on:after,
.area-result .solution-area .mypage-area .mypage-bottom .tab__line li:hover:after {
  height: 3px;
}
.mypage-area .mypage-bottom .item-list-top,
.m-m10 .item-list-top,
.community .solution-area .m-m10 .mypage-bottom .item-list-top {
  margin: 0 0 16px;
  width: 100%;
  align-items: center;
}
.community .solution-area .mypage-bottom .item-list-top .left,
.community .solution-area .mypage-bottom .item-list-top .right {
  gap: 8px;
}
.community .solution-area .mypage-bottom .item-list-top .left p {
  font-size: 0.813rem;
  font-weight: 400;
  color: #7783a1;
}
.community .solution-area .mypage-bottom .item-list-top .left p.tit {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.25;
  color: var(--secondary);
  margin-top: 8px;
}
.community .solution-area .mypage-bottom .item-list-top .right .btn-basic + .btn-basic {
  margin-left: 0;
}
.community .solution-area .mypage-bottom .item-list-top .right button.small {
  height: 20px !important;
  padding: 0 8px;
  border-radius: 25px;
}
.community .solution-area .mypage-bottom .item-list-top .right button.small span {
  font-size: 12px !important;
  font-weight: 400;
}
.community .solution-area .mypage-bottom .item-list-top .right button.btn i {
  margin-bottom: -4px;
  width: 24px;
  height: 24px;
}
.list-area > li {
  padding: 12px 0;
  border-top: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.list-area > li > .list-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 5px;
}
.list-area > li > .list-top > .left,
.list-area > li > .list-top > .right {
  display: flex;
  align-items: center;
  gap: 11px;
}
/* .list-area > li > .list-top > .left {
  flex: 1;
  max-width: 80%;
} */
.list-area > li > .list-top > .left {
}
.list-area > li > .list-top > .right {
  justify-content: flex-end;
  width: auto;
  flex: 1;
}
/* .list-area > li > .list-top > .left + .right {
  width: auto;
} */
.list-area > li > .list-top > .left p {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  color: var(--secondary);
  width: 100%;
}
.list-area > li > .list-top > .right p {
  color: #7783a1;
  font-size: 0.75rem;
}
.list-area > li > .list-top .btn-alarm {
  position: relative;
  width: 16px;
  height: 16px;
  border: 4px solid #fff;
  background: #0978ff;
  border-radius: 50px;
}
.list-area > li > .list-top .btn-alarm:hover::before {
  content: '읽음으로 표시';
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 22px;
  width: 85px;
  height: 18px;
  font-weight: 400;
  font-size: 12px;
  color: #2a2c2f;
  background: #dde2e9;
  border-radius: 10px;
  z-index: 1000;
}
.list-area > li > .list-top .btn-alarm:hover:after {
  content: '';
  position: absolute;
  left: -5px;
  top: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50px;
  background: transparent;
  border: 1px solid#0A78FF;
}
.list-area > li > .list-top .btn-alarm.readend {
  width: 16px;
  height: 16px;
  border: 1px solid #515d6f;
  background: transparent;
}
.list-area > li > .list-top .btn-alarm.readend:hover:before {
  content: '안읽음으로 표시';
  width: 108px;
  right: 24px;
}
.list-area > li > .list-top .btn-alarm.readend:hover:after {
  content: none;
}
.list-area > li > .list-bottom {
  border: 1px solid var(--border);
  padding: 12px;
}
.list-area > li > .list-bottom > a {
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
}
.list-area > li > .list-bottom > a .top {
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin: 0;
}
.list-area > li > .list-bottom > a .top .cate {
  font-size: 0.625rem;
  font-weight: 500;
  color: #fff;
  padding: 0 8px;
  height: 20px;
  background: var(--gray-20);
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}
.list-area > li > .list-bottom > a .top .cate.set-blue {
  background: var(--point-01);
}
.list-area > li > .list-bottom > a .top .cate.set-teal {
  background: var(--point-02);
}
.list-area > li > .list-bottom > a .top .cate.set-yellow {
  background: var(--point-03);
}
.list-area > li > .list-bottom > a .top .cate.set-magenta {
  background: var(--point-04);
}
.list-area > li > .list-bottom > a .top .cate.set-navy {
  background: var(--point-05);
}
.list-area > li > .list-bottom > a .top .cate.set-green {
  background: var(--point-06);
}
.list-area > li > .list-bottom > a .top p {
  font-size: 0.813rem;
  font-weight: 400;
  color: var(--secondary);
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}
.list-area > li > .list-bottom > a .bottom {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.list-area > li > .list-bottom > a .bottom p {
  font-size: 0.813rem;
  line-height: 1.4;
  color: var(--secondary);
  flex: 1;
}
.list-area > li > .list-bottom > a .bottom p.answer {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-area > li > .list-bottom > a .bottom p.answer::before {
  content: '';
  display: inline-block;
  vertical-align: bottom;
  margin-right: 4px;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat center center;
  background-size: 100%;
}
.list-area > li > .list-bottom > a .bottom p.answer.others::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) no-repeat center center;
}
.list-area > li > .list-bottom > a .bottom p.info {
  display: flex;
}
.list-area > li > .list-bottom > a .bottom p.info::before {
  content: '';
  display: inline-block;
  vertical-align: bottom;
  margin-right: 4px;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center -1px;
  background-size: 100%;
  flex: none;
}
.list-area > li > .list-bottom > a .bottom p.move::before {
  content: '';
  display: inline-block;
  vertical-align: bottom;
  margin-right: 4px;
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) no-repeat center center;
  background-size: 100%;
}
.list-area > li > .list-bottom > a .bottom strong {
  font-weight: 500;
}
.mypage-bottom .list-area + .txt-info {
  margin: 80px 0 160px 0;
  font-size: 13px;
  color: #8898b7;
  line-height: 1.4;
  text-align: center;
}

@media screen and (max-width: 1278px) {
  .community .mypage-area {
    margin-top: 0;
  }
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive).page-market.community .write-box .input__direct {
    height: 32px;
  }
  .community .shadow-box > .mypage-top {
    flex-direction: column;
    gap: 20px;
    padding: 32px;
  }
}
@media screen and (max-width: 732px) {
  .community .shadow-box > .mypage-bottom {
    flex-direction: column;
  }
  .mypage-bottom > .left,
  .mypage-bottom > .left .lnb > li.on {
    width: 100%;
    border-right: 0;
  }
  .mypage-bottom > .left {
    position: relative;
  }
  .mypage-bottom > .right {
    padding: 8px 20px;
    width: calc(100% - 40px);
  }
  .mypage-bottom > .left .lnb__toggleBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    width: calc(100% - 40px);
    height: 47px;
    background: #fff;
    border-bottom: 1px solid #dde2e9;
    cursor: pointer;
  }
  .mypage-bottom > .left:after {
    content: '';
    width: 100%;
    height: 8px;
    position: absolute;
    bottom: -8px;
    left: 0;
    background: linear-gradient(180deg, rgba(144, 159, 183, 0.0001) 10%, rgba(144, 159, 183, 0.2) 100%);
    transform: rotate(-180deg);
  }
  .mypage-bottom > .left .lnb__toggleBtn p {
    color: #2a2c2f;
    font-size: 16px;
    font-weight: 700;
  }
  .mypage-bottom > .left .lnb__toggleBtn::after {
    content: '';
    width: 20px;
    height: 20px;
    margin-left: 40px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) no-repeat center center;
    background-size: 100%;
  }
  .mypage-bottom > .left .lnb__toggleBtn.active::after {
    content: '';
    transform: rotate(180deg);
  }
  .mypage-bottom > .left .lnb {
    display: none;
  }
  .mypage-bottom > .left .lnb.active {
    display: flex;
    position: absolute;
    top: 48px;
    z-index: 2;
    left: 0;
    width: 100%;
    background: #f7f8fa;
    box-shadow: 0px 4px 4px 0px rgba(67, 85, 131, 0.25);
  }
}
@media screen and (max-width: 500px) {
  #wrap:not(.no-responsive).community .solution-area .mypage-bottom .item-list-top .right button.small.btn-basic {
    padding: 0 8px;
  }
}
@media screen and (max-width: 499px) {
  #wrap.page-market.community.detail > .container .content.mypage {
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 0 10px;
    width: calc(100% - 20px);
  }
  .community .mypage-area.shadow-box {
    margin-top: 0;
    box-shadow: none;
  }
  .community .shadow-box > .mypage-top {
    padding: 40px 20px 20px;
  }
}

/* Community - detail - 마이페이지 - 내게시글 */
.mypage-bottom .item-list-area > .item-list-top .left,
.community .solution-area .mypage-bottom .item-list-area > .item-list-top .left {
  gap: 24px;
}
.mypage-bottom .item-list-area > .item-list-top .select {
  border: 0;
  height: auto;
}
.mypage-bottom .item-list-area > .item-list-top .select.active {
  font-weight: 500;
}
.community .area-result .solution-area .mypage-bottom .item-list-area > .item-list-top .select .selected {
  padding: 0;
}
.community .area-result .solution-area .mypage-bottom .item-list-area > .item-list-top .select ul li {
  padding: 16px 24px;
  font-size: 15px;
  width: calc(100% - 48px) !important;
}
.community .area-result .mypage-bottom .item-list-area .item-list > li {
  max-width: 320px;
  height: 306px;
}

@media screen and (max-width: 1562px) {
  .community .area-result .mypage-area .item-list {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 1300px) {
  .community .area-result .mypage-area .item-list {
    grid-template-columns: repeat(2, 49.2%);
  }
  .community .area-result .mypage-bottom .item-list-area .item-list > li {
    max-width: 100%;
  }
}
@media screen and (max-width: 940px) {
  .community .area-result .mypage-area .item-list {
    grid-template-columns: repeat(1, 100%);
  }
}

/* Community - detail - 마이페이지 - 내정보 */
.community .area-result .mypage-bottom .box {
  padding: 24px;
  border: 1px solid var(--border);
  border-radius: 0;
  box-shadow: none;
  min-height: 426px;
}
.community .area-result .mypage-bottom .box .form__input li {
  gap: 42px;
}
.community .area-result .mypage-bottom .box .form__input label {
  min-width: 94px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  letter-spacing: -0.04em;
}
.community .area-result .mypage-bottom .box .form__input .input__area {
  width: 280px;
}
.community .area-result .mypage-bottom .box .form__input .input__area input[type='text'],
.community .area-result .mypage-bottom .box .form__input .input__area input[type='password'],
.community .area-result .mypage-bottom .box .form__input .input__area input[type='tel'],
.community .area-result .mypage-bottom .box .form__input .input__area input[type='file'] {
  height: 30px;
}
.community .area-result .mypage-bottom .box .form__input button[class*='-txt'] span {
  font-size: 14px;
}
.community .mypage-bottom .banner-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  min-height: 66px;
  padding: 32px 16px 16px 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) no-repeat 0 0;
  background-size: cover;
}
.community .mypage-bottom .banner-box::after {
  content: '';
  position: absolute;
  top: 16px;
  right: 16px;
  width: 48px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_35___}) no-repeat center center;
  background-size: 100%;
}
.community .mypage-bottom .banner-box p {
  font-size: 14px;
  line-height: 1.4;
  font-weight: 400;
  color: var(--secondary);
  letter-spacing: -0.07em;
}
.community .mypage-bottom .banner-box p strong {
  font-size: 20px;
  font-weight: 700;
  color: #003378;
}
.community .mypage-bottom .banner-box .right {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
}
.community .mypage-bottom .banner-box .right button {
  padding: 0 16px;
  height: 46px;
  border-radius: 25px;
  background: rgba(10, 120, 255, 0.8);
  border-color: rgba(10, 120, 255, 0.8);
}
.community .mypage-bottom .banner-box .right button[class*='-line'] {
  border-color: #fff;
  background: rgba(255, 255, 255, 0.2);
  min-width: 132px;
}
.community .mypage-bottom .banner-box .right button[class*='-line'] span {
  color: #646c74;
  font-size: 15px;
}
@media screen and (max-width: 1240px) {
  .community .mypage-bottom .banner-box {
    flex-direction: column;
    gap: 16px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) no-repeat center center;
    background-size: cover;
  }
}
@media screen and (max-width: 940px) {
  #wrap:not(.no-responsive).community .mypage-bottom .banner-box .right button.btn-basic {
    height: 46px;
  }
  #wrap:not(.no-responsive).community .mypage-bottom .banner-box .right button.btn-basic span {
    font-size: 14px;
  }
  .community .area-result .mypage-bottom .box .form__input li {
    flex-direction: row;
    align-items: unset;
  }
  .community .area-result .mypage-bottom .box {
    min-height: 386px;
  }
}
@media screen and (max-width: 732px) {
  .mypage-area .mypage-bottom .item-list-top,
  .m-m10 .item-list-top,
  .community .solution-area .m-m10 .mypage-bottom .item-list-top {
    margin: 0 0 12px;
  }
  .community .solution-area .mypage-bottom .item-list-top .left p.tit {
    display: none;
  }
}
@media screen and (max-width: 500px) {
  .community .area-result .mypage-bottom .box .form__input li {
    margin-top: 0;
  }
}
@media screen and (max-width: 499px) {
  .community .area-result .mypage-bottom .box .form__input li {
    flex-direction: column;
    gap: 10px;
  }
  .community .area-result .mypage-bottom .box .form__input label {
    min-width: 100%;
    font-size: 15px;
  }
  .community .area-result .mypage-bottom .box .form__input button[class*='-txt'] {
    margin: 10px 0;
  }
  .community .area-result .mypage-bottom .box .form__input button[class*='-txt'] span {
    font-size: 16px;
  }
  .community .area-result .mypage-bottom .box .form__input .input__area {
    width: 100%;
  }
  .community .area-result .mypage-bottom .box .form__input .input__area input[type='text'],
  .community .area-result .mypage-bottom .box .form__input .input__area input[type='password'],
  .community .area-result .mypage-bottom .box .form__input .input__area input[type='tel'],
  .community .area-result .mypage-bottom .box .form__input .input__area input[type='file'] {
    height: 38px;
    font-size: 1rem;
  }
  .community .area-result .mypage-bottom .box .form__input label.txt-transparent {
    display: none;
  }
  .community .mypage-bottom .banner-box .right {
    flex-wrap: wrap;
  }
  .community .mypage-bottom .list-area > li > .list-top {
    flex-direction: column;
    align-items: flex-start;
  }
  .list-area > li > .list-top > .left {
    width: 100%;
  }
  .list-area > li > .list-top > .right {
    width: 100%;
  }
}

/* Community - detail - 마이페이지 - 마켓 플레이스 Like 목록 */
.community .area-result .mypage-bottom .item-list-area .item-list.item-like > li {
  height: 526px;
  background: var(--white);
  border: 1px solid var(--border);
}
.community .area-result .item-list.item-like > li .item-info {
  height: calc(100% - 200px);
  padding: 0;
}
.community .area-result .item-list.item-like > li .item-info-top {
  margin-top: 0;
  height: calc(100% - 80px);
  padding: 16px;
}
.community .area-result .item-list.item-like > li .item-info:hover::before,
.community .area-result .item-list.item-like > li .item-info:active::before {
  content: none;
}
.item-list.item-like li .img-wrap .tit {
  left: 32px;
  z-index: unset;
}
.community .area-result .item-list.item-like > li .etc {
  margin-top: 16px;
  justify-content: flex-start;
}
.item-list.item-like .item-info-top .company {
  margin-top: 4px;
}
.item-list.item-like .item-info-top .cont {
  margin-top: 8px;
}
.area-result .item-list.item-like .item-info-top .tit {
  line-height: 1.7;
  padding: 0;
}

/* Community - 팝업 - 프로필이미지 수정 */
.community .pop-profile {
  width: 256px;
  position: absolute;
  top: 80px;
  left: 0;
  background: var(--gray-00);
  border-radius: 8px;
  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);
  z-index: 2;
  display: none;
}
.community .pop-profile.open {
  display: block;
}
.community .pop-profile .popup__body {
  padding: 12px;
  width: calc(100% - 24px);
}
.community .pop-profile .img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.community .pop-profile .img-list > li {
  width: 72px;
  height: 72px;
  background: #eef1f6;
  border-radius: 50%;
}
.community .pop-profile .img-list > li > a {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 10px;
  line-height: 1.6;
  color: var(--gray-20);
  font-weight: 500;
}
.community .pop-profile .img-list > li > a:before {
  content: '';
  width: 24px;
  height: 24px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center center;
  background-size: 100%;
}
.community .pop-profile .img-list > li > a.delete:before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center center;
  background-size: 100%;
}

/* Community - 팝업 - 회원등급 안내 */
.rank-info-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 34px;
  margin-bottom: 32px;
}
.rank-info-list > li {
  display: flex;
  gap: 8px;
  font-size: 14px;
  color: var(--secondary);
  line-height: 1.4;
  font-weight: 400;
  letter-spacing: -0.04em;
}
.rank-info-list > li strong {
  min-width: 40px;
  font-weight: 500;
  color: var(--primary);
}

/* Community - 팝업 */
.community .popup-layer.popup-basic {
  width: 320px;
}
.community .popup__body,
.pop-login .popup__body {
  max-height: calc(85vh - 7.5rem);
}
.community .popup__footer button {
  width: auto;
  min-width: 120px;
}
.pop-login .popup__footer button {
  width: auto;
  flex: 1;
  max-width: 120px;
  padding: 0 10px;
}
.community .popup__footer button[class*='w'],
.pop-login .popup__footer button[class*='w'] {
  flex: none;
}
.community .popup__body .form__input .radioBox label,
.pop-login .popup__body .form__input .radioBox label {
  width: auto;
  font-weight: 500;
}
.community .popup__body .form__input .radioBox.col label,
.pop-login .popup__body .form__input .radioBox.col label {
  margin-bottom: 0;
}

/* Community - 로그인 팝업 */
#wrap.page-market .pop-login .popup__body .login-wrap {
  width: auto;
  height: auto;
  min-height: auto;
  padding: 0;
  margin: 26px 4px 32px;
  border-top: 0;
  background: none;
}
#wrap.page-market .pop-login .popup__body .login-wrap > p {
  font-size: 0.938rem;
}
#wrap.page-market .pop-login .login__form {
  width: 100%;
}
#wrap.page-market .pop-login .popup__body .login-wrap .login__form .form__input {
  margin: 32px 0 40px;
}
#wrap.page-market .pop-login .popup__body .login-wrap .login__form .form__input li {
  margin-top: 8px;
}
#wrap.page-market .pop-login .login__form .form__input input[type='text'],
#wrap.page-market .pop-login .login__form .form__input input[type='password'] {
  height: 38px;
  width: calc(100% - 34px);
  font-size: 1rem;
}
#wrap.page-market .pop-login .login__form .form__input input[type='text']::placeholder,
#wrap.page-market .pop-login .login__form .form__input input[type='password']::placeholder {
  font-size: 1rem !important;
}
#wrap.page-market .pop-login .login__form .form__etc button[class*='-txt'] {
  gap: 0;
}
#wrap.page-market .pop-login .btn-login {
  margin: 58px 0 24px;
  width: 100%;
  height: 46px;
}
#wrap.page-market .pop-login .btn-login span {
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
}
#wrap.page-market .pop-login .join li p {
  font-size: 14px;
  font-weight: 400;
}
#wrap.page-market .pop-login .join li .btn-txt span {
  font-size: 14px;
  font-weight: 500;
}
#wrap.page-market .pop-login .select-lang {
  margin-top: 40px;
  gap: 24px;
}
#wrap.page-market .pop-login .select-lang button {
  margin-left: 0;
  height: 20px !important;
}
#wrap.page-market .pop-login .select-lang button span {
  font-size: 12px;
  color: #909fb7 !important;
}
#wrap.page-market .pop-login .select-lang button:hover span,
#wrap.page-market .pop-login .select-lang button:active span,
#wrap.page-market .pop-login .select-lang button.on span {
  color: #0a78ff !important;
  font-weight: 500;
}
@media screen and (max-width: 940px) {
  .community .popup__body,
  #wrap.page-market .pop-login .popup__body {
    max-height: calc(85vh - 7.5rem);
  }
  #wrap.page-market.community .popup__body .login-wrap .login__form .form__input,
  #wrap.page-market .pop-login .popup__body .login-wrap .login__form .form__input {
    gap: 0;
  }
}

/* Community - 회원가입 팝업 */
.pop-login.popup-type1 .popup__body {
  padding: 24px 20px 17px;
  width: calc(100% - 40px);
  max-height: calc(68vh - 7.5rem);
}
#wrap.page-market .pop-login.popup-type1 .popup__body .terms {
  height: calc(68vh - 7.5rem);
}
.pop-login.popup-type1 .popup__body .form__input li {
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
}
.pop-login.popup-type1 .popup__body .form__input li:first-child {
  margin-top: 0;
}
.pop-login.popup-type1 .popup__body .form__input label {
  width: 100%;
  font-size: 15px;
}
.pop-login.popup-type1 .popup__body .form__input label.star:after {
  font-size: 14px;
  vertical-align: top;
}
.community .pop-login.popup-type1 .popup__body .input__area .select {
  width: 100%;
  height: 38px;
}
.community .pop-login input[type='checkbox'] + label,
.pop-login.popup-type1 .popup__body .form__input input[type='checkbox'] + label {
  padding-left: 30px;
  width: auto !important;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: -0.04em;
}
.community .pop-login input[type='checkbox'] + label:before {
  width: 20px;
  height: 20px;
}
.community .pop-login input[type='checkbox']:checked + label:after {
  width: 20px;
  height: 20px;
  background-size: auto;
}
.input-info {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 2px;
}
.input-info > span,
.input-info > li {
  display: flex;
  gap: 2px;
  font-size: 14px;
  line-height: 1.6;
  font-weight: 400;
  color: var(--secondary);
  letter-spacing: -0.04em;
}
.input-info > span::before,
.input-info > li::before {
  content: '*';
}
.input-errortxt + .input-info {
  margin-top: 21px;
}
.pop-login.popup-type1 .popup__body .tab__line {
  margin: -16px -20px 24px;
  width: calc(100% + 40px);
  gap: 0;
}
.pop-login.popup-type1 .popup__body .tab__line li {
  flex: 1;
}
.pop-login.popup-type1 .popup__body .tab__line li.on {
  font-weight: 700;
}
#wrap.page-market .pop-login .popup__body.joinok-h {
  padding: 0 20px 49px;
  width: calc(100% - 40px);
}
#wrap.page-market .pop-login .popup__body.joinok-h .complete-txt button {
  width: 100%;
  height: 46px;
}
.pop-login .popup__body.find-company {
  min-height: calc(68vh - 7.5rem);
}
.pop-login .popup__body.find-idpw {
  min-height: calc(54vh - 7.5rem);
}
.pop-login .popup__body.find-idpw .complete-txt {
  height: calc(54vh - 7.5rem);
  margin-top: 0;
}
.pop-login .popup__body.find-idpw .complete-txt p {
  margin-top: 16px;
  font-weight: 400;
  color: #2a2c2f;
  text-align: center;
  font-size: 15px;
}
.pop-login .popup__body.find-idpw .complete-txt .tit {
  font-size: 15px;
  line-height: 1.4;
  letter-spacing: -0.69px;
}
.pop-login .popup__body.find-idpw .radioBox input[type='radio'] {
  vertical-align: middle;
}

/* Community - 레이어 팝업박스 */
.pop-layer-box {
  display: none;
  flex-direction: column;
  gap: 0;
  position: absolute;
  border: 1px solid var(--border);
  background: #fff;
  box-shadow: var(--shadow-07);
  border-radius: 10px;
  z-index: 2;
}
.pop-layer-box.show {
  display: flex;
}
.pop-layer-box .pop-head {
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
}
.pop-layer-box .pop-head h1 {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--secondary);
  line-height: 1.3;
  letter-spacing: -0.02em;
}
.pop-layer-box .pop-bottom {
  padding: 8px 12px;
  border-top: 1px solid var(--border);
}
.pop-layer-box .pop-bottom .txt-info {
  margin: 0;
  font-size: 10px;
  color: var(--secondary);
  line-height: 16px;
}
.pop-layer-box .pop-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pop-layer-box .pop-body p {
  font-size: 0.813rem;
  line-height: 1.4;
  letter-spacing: -0.045em;
  color: var(--secondary);
}
.pop-layer-box .pop-body p strong {
  font-weight: 500;
}
/*임시저장 레이어 팝업박스*/
.pop-layer-box.save {
  top: 24px;
  right: -2px;
  min-height: 200px;
  width: 206px;
}
.pop-layer-box.save .list {
  width: 100%;
  min-height: 116px;
}
.pop-layer-box.save .list > li {
  border-bottom: 1px solid var(--border);
}
.pop-layer-box.save .list > li:first-child {
  border-bottom: 1px solid var(--border) !important;
}
.pop-layer-box.save .list > li:last-child {
  border-bottom: 0;
}
.pop-layer-box.save .list > li > a {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 24px;
}
.pop-layer-box.save .list > li .tit {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.813rem;
  font-weight: 500;
  line-height: 1.4;
}
.pop-layer-box.save .list > li .date {
  font-size: 0.625rem;
  line-height: 1.6;
  color: var(--gray-40);
}
.pop-layer-box.save .list > li > a:hover {
  background: var(--input-hover);
}
.pop-layer-box.save .list > li > a:hover .tit {
  color: var(--primary);
}

/*메인 좌우플로팅박스 안내 레이어 팝업박스*/
.pop-layer-box.info {
  width: 320px;
  left: 152px;
  top: 38px;
}
.pop-layer-box.info .pop-body {
  display: block;
  padding: 10px 24px 20px;
}
.pop-layer-box.info.tag {
  right: 20px;
  left: unset;
}
.pop-layer-box.info.tag .pop-body {
  min-height: 62px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.pop-layer-box.info .list-item {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.pop-layer-box.info .list-item li {
  display: flex;
  align-items: center;
  gap: 8px;
}
.pop-layer-box.info .list-item li i {
  width: 24px;
  height: 24px;
}

/* Community - 팝업 - 메인 공지사항 */
.popup-layer-news {
  position: fixed;
  left: 100px;
  top: 101px;
  width: 320px;
  background: #fff;
  box-shadow: 0px 10px 30px 0px rgba(42, 44, 47, 0.5);
  z-index: 1000;
}
.popup-layer-news.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.popup-layer-news .popup__head {
  padding: 12px 16px;
  width: calc(100% - 32px);
  justify-content: flex-end;
  border: 0;
}
.popup-layer-news .popup__head .btn-close {
  width: 24px;
  height: 24px;
  background-size: 14px;
}
.popup-layer-news .popup__body {
  padding: 0;
  width: 100%;
}
.popup-layer-news .popup__body h1 {
  font-size: 14px;
  line-height: 1.4;
  font-weight: 700;
  color: var(--secondary);
  padding: 0 16px 8px;
}
.popup-layer-news .popup__body > a {
  width: 100%;
}
.popup-layer-news .popup__body > a > img {
  width: 100%;
}
.popup-layer-news .filelist,
.community .popup-layer-news .filelist {
  margin: 8px 16px 0 40px;
}
.popup-layer-news .filelist li,
.community .popup-layer-news .filelist li {
  margin-bottom: 4px;
  display: block;
}
.popup-layer-news .popup__footer {
  border: 0;
}
.popup-layer-news .popup__footer input[type='checkbox'] + label {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: -0.04em;
}
.popup-layer-news .popup__footer input[type='checkbox'] + label:before,
.popup-layer-news .popup__footer input[type='checkbox']:checked + label:after {
  top: 4px;
}
.popup-layer-news .popup__footer input[type='checkbox']:checked + label:after {
  background-size: 87%;
}

/* Community - 라디오박스 */
.community .radioBox.col {
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.community .radioBox.col > li {
  margin-top: 0;
  flex-direction: column;
  gap: 16px;
}
.community .form__input input[type='text'],
.community .form__input input[type='password'],
.community .form__input input[type='tel'],
.community .form__input input[type='file'] {
  height: 38px;
}
.community .popup__body p.input-errortxt {
  top: 2.65rem;
  font-size: 0.75rem;
}
.community .input__area .select,
.community .area-result .solution-area .write-area .top .select {
  width: auto;
  height: 1.875rem;
  border: 1px solid var(--gray-20);
}
.community .input__area .select.active,
.community .area-result .solution-area .write-area .top .select.active {
  border-color: #0d78ff;
}
.community .area-result .solution-area .write-area .top .select {
  min-width: 280px;
}
.community .input__area .select .selected,
.community .area-result .solution-area .write-area .top .select .selected {
  padding: 0 12px;
}
.community .area-result .solution-area .write-area .top .select .selected .arrow {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat center center;
  background-size: 100%;
}
.community .area-result .solution-area .write-area .top .select.active ul {
  display: initial;
  border-color: #0d78ff;
  border-radius: 0 0 4px 4px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 200px;
  width: 100% !important;
  max-width: 100% !important;
  margin-top: -0.5px;
  box-shadow: none;
}
.community .area-result .solution-area .write-area .top .select ul li {
  width: calc(100% - 1.5rem) !important;
  padding: 0.563rem 0.75rem !important;
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
}

/* 이메일 인증 완료 */
.community .webmailok {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 62px);
}
.community .webmailok .login__form {
  margin-top: -63px;
}
.community .webmailok .login__form .login__info {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #2a2c2f;
}
.community .webmailok .login__form .login__info::before {
  content: '';
  margin: 0 auto 16px;
  width: 100px;
  height: 100px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___}) no-repeat center center;
  background-size: 100%;
}
#wrap.page-market.community .webmailok .btn-login {
  margin: 40px auto 0;
  width: 310px;
}
#wrap.page-market.community .webmailok .btn-login span {
  font-weight: 700;
}

@media screen and (max-width: 1278px) {
  .community .webmailok {
    min-height: calc(100vh - 102px);
  }
}
`, "",{"version":3,"sources":["webpack://./static/css/community.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,sGAAsG;AACtG,SAAS;AACT;EACE,OAAO;EACP,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;;EAEf,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;;EAEvB,qDAAqD;EACrD,qDAAqD;EACrD,oDAAoD;EACpD,sDAAsD;EACtD,oDAAoD;EACpD,mDAAmD;EACnD,sDAAsD;;EAEtD,gFAAgF;AAClF;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yCAAyC;AAC3C;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;;AAEA,SAAS;AACT;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,2EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,2EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,2EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,2EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,2EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,2EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,2EAAqE;EACrE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,2EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,2EAAsE;EACtE,qBAAqB;AACvB;AACA;EACE,2EAA8D;EAC9D,qBAAqB;AACvB;AACA;;EAEE,4EAAsE;AACxE;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;AACA;EACE,4EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,4EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,4EAA0E;EAC1E,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,YAAY;AACd;AACA;EACE,SAAS;EACT,UAAU;EACV,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,OAAO;AACT;AACA;EACE,uCAAuC;AACzC;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,cAAc;AACd;;;EAGE,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA,QAAQ;AACR;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,2EAA8D;AAChE;AACA;EACE,4EAAiE;AACnE;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,qEAA+D;AACjE;AACA;;EAEE,qEAAkE;AACpE;AACA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0EAA8D;EAC9D,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,yBAAyB;AAC3B;AACA,4BAA4B;AAC5B;EACE,eAAe;EACf,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4EAAiE;AACnE;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,6DAA6D;EAC7D,SAAS;AACX;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;AACA;;EAEE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,QAAQ;AACV;AACA;EACE,4EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iDAAiD;EACjD,6CAA6C;AAC/C;AACA;EACE,kDAAkD;EAClD,8CAA8C;AAChD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,mEAAmE;EACnE,SAAS;AACX;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,4EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,4EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,4EAA+D;EAC/D,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,oDAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,oDAA0C;EAC1C,qBAAqB;AACvB;AACA;EACE,oDAAsC;EACtC,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,qEAAqE;IACrE,uCAAuC;EACzC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,8BAA8B;EAChC;EACA;;KAEG;EACH;;IAEE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;;IAEE,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4DAA4D;EAC5D,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,YAAY;EACZ,qCAAqC;AACvC;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,WAAW;EACX,YAAY;EACZ,4EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yEAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,4EAAsE;EACtE,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;EAEE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,qCAAqC;EACrC,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;;EAEE,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;AACpC;AACA;;EAEE,mCAAmC;EACnC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,wBAAwB;IACxB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,mCAAmC;IACnC,uCAAuC;EACzC;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,MAAM;EACR;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;EACb,aAAa;AACf;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;AACA;;;GAGG;AACH;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;;EAEE,SAAS;EACT,UAAU;AACZ;AACA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,OAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;;EAEd,YAAY;EACZ,aAAa;AACf;AACA;;;;;;EAME,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,iCAAiC;EACnC;EACA;IACE,SAAS;EACX;EACA;;IAEE,YAAY;EACd;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,OAAO;EACT;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,QAAQ;EACV;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,OAAO;IACP,sBAAsB;EACxB;AACF;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oGAA4F;EAC5F,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,UAAU;EACV,OAAO;AACT;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,WAAW;AACb;AACA;;;EAGE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;AACV;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;;;GAGG;AACH;AACA;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,OAAO;AACT;AACA;;GAEG;AACH;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,OAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,OAAO;AACT;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,4EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,yEAA6D;EAC7D,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,4EAA+D;EAC/D,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;;IAEE,WAAW;IACX,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;EACjB;EACA;IACE,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,mGAAmG;IACnG,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4EAA0E;IAC1E,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,mDAAmD;EACrD;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,sCAAsC;AACtC;;EAEE,SAAS;AACX;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;;;;EAIE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,kEAAwD;EACxD,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,4EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,4EAAyE;IACzE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;;;IAGE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;;;;IAIE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,UAAU;AACZ;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,0BAA0B;EAC1B,kBAAkB;EAClB,qDAAqD;EACrD,UAAU;EACV,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,4EAAkE;EAClE,qBAAqB;AACvB;AACA;EACE,4EAAiE;EACjE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,YAAY;AACd;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,MAAM;AACR;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE;;IAEE,+BAA+B;EACjC;EACA;;IAEE,MAAM;EACR;AACF;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;AACV;AACA;;EAEE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;;EAEE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,MAAM;AACR;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA,gBAAgB;AAChB;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;AACf;AACA;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,QAAQ;AACV;AACA;EACE,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;;;EAIE,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,4EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF","sourcesContent":["@charset \"UTF-8\";\r\n\r\n/********************************************* Community *********************************************/\r\n/* root */\r\n:root {\r\n  /* 컬러 */\r\n  --primary: #0a78ff;\r\n  --primary-hover: #0050b8;\r\n  --primary-active: #003876;\r\n  --secondary: #2a2c2f;\r\n  --secondary-hover: #142c4c;\r\n  --secondary-active: #1f3e68;\r\n  --point-01: #577eff;\r\n  --point-02: #00a985;\r\n  --point-03: #d6a833;\r\n  --point-04: #c70060;\r\n  --point-05: #2c364e;\r\n  --point-06: #005b09;\r\n  --point-01-bg: #f2f5fb;\r\n  --point-02-bg: #ebf9f6;\r\n  --point-03-bg: #fffff7;\r\n  --point-04-bg: #fff6f7;\r\n  --point-05-bg: #f8f9fb;\r\n  --point-06-bg: #f8fff6;\r\n  --dark-red: #900d19;\r\n  --red: #ff0000;\r\n  --sky: #e7f2ff;\r\n  --dark-green: #006a65;\r\n  --navy: #051c3f;\r\n  --dark-navy: #0a1e5a;\r\n  --gray-90: #101a2d;\r\n  --gray-80: #26282e;\r\n  --gray-70: #2a2c2f;\r\n  --gray-60: #2c364e;\r\n  --gray-50: #576274;\r\n  --gray-40: #646c74;\r\n  --gray-30: #7783a1;\r\n  --gray-20: #909fb7;\r\n  --gray-10: #dde2e9;\r\n  --gray-05: #f2f5fb;\r\n  --gray-00: #fff;\r\n\r\n  --border: #dde2e9;\r\n  --placeholder: #909fb7;\r\n  --input-hover: #e6f0ff;\r\n  --input-select: #b4d2ff;\r\n\r\n  --shadow-01: 0px 2px 10px 0px rgba(67, 85, 131, 0.07);\r\n  --shadow-02: 0px 2px 10px 0px rgba(67, 85, 131, 0.25);\r\n  --shadow-03: 0px 2px 10px 0px rgba(67, 85, 131, 0.5);\r\n  --shadow-04: 0px 4px 10px 0px rgba(122, 133, 150, 0.5);\r\n  --shadow-05: 0px 1px 4px 0px rgba(67, 85, 131, 0.25);\r\n  --shadow-06: 0px 2px 7px 0px rgba(67, 85, 131, 0.5);\r\n  --shadow-07: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);\r\n\r\n  --gradation-01: linear-gradient(180deg, #f7f8fa 0%, rgba(247, 248, 250, 0) 100%);\r\n}\r\n.bg-primary {\r\n  background: var(--primary) !important;\r\n}\r\n.primary {\r\n  color: var(--primary) !important;\r\n}\r\n.red {\r\n  color: var(--red) !important;\r\n}\r\n.navy,\r\n.btn-txt span.navy {\r\n  color: var(--navy) !important;\r\n}\r\n.bg-gray60 {\r\n  background: var(--gray-60) !important;\r\n}\r\n.point-01-bg {\r\n  background: var(--point-01-bg) !important;\r\n}\r\n.gray30,\r\n.btn-txt span.gray30 {\r\n  color: var(--gray-30) !important;\r\n}\r\n.shadow-1 {\r\n  box-shadow: var(--shadow-02);\r\n}\r\n.shadow-2 {\r\n  box-shadow: var(--shadow-02);\r\n}\r\n.shadow-3 {\r\n  box-shadow: var(--shadow-02);\r\n}\r\n.shadow-4 {\r\n  box-shadow: var(--shadow-02);\r\n}\r\n.shadow-5 {\r\n  box-shadow: var(--shadow-02);\r\n}\r\n.shadow-6 {\r\n  box-shadow: var(--shadow-02);\r\n}\r\n\r\n.border-1 {\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n/* border-radius */\r\n.b-radius0 {\r\n  border-radius: 0 !important;\r\n}\r\n.b-radius2 {\r\n  border-radius: 2px !important;\r\n}\r\n.b-radius4 {\r\n  border-radius: 4px !important;\r\n}\r\n\r\n/* icon */\r\ni {\r\n  display: block;\r\n  width: 16px;\r\n  height: 16px;\r\n  flex: none;\r\n}\r\ni.w20 {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\ni.w24 {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.icon-best {\r\n  background: url('../img/icon_best.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-best2 {\r\n  background: url('../img/icon_best2.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-best3 {\r\n  background: url('../img/icon_best3.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-info {\r\n  background: url('../img/icon_info.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-like {\r\n  background: url('../img/icon_like_darknavy.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-arrow-small {\r\n  background: url('../img/icon_arrow_small.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-arrow-large {\r\n  background: url('../img/icon_arrow_blue.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-arrow-large-next {\r\n  background: url('../img/icon_arrow_blue.svg') no-repeat center center;\r\n  background-size: 100%;\r\n  transform: rotate(-90deg);\r\n}\r\n.icon-arrow-line {\r\n  background: url('../img/icon_arrow_line.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-arrow-line2 {\r\n  background: url('../img/icon_arrow_line2.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-pen {\r\n  background: url('../img/icon_pen.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\ni.icon-pen:hover,\r\ni.icon-pen:active {\r\n  background: url('../img/icon_pen_primary.svg') no-repeat center center;\r\n}\r\n.icon-delete {\r\n  background: url('../img/icon_delete.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-picture {\r\n  background: url('../img/icon_picture.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-setting {\r\n  background: url('../img/icon_setting.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.icon-setting-primary {\r\n  background: url('../img/icon_setting_primary.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n\r\n/* button */\r\nbutton.xlarge {\r\n  height: 48px !important;\r\n}\r\nbutton.large {\r\n  height: 42px !important;\r\n}\r\nbutton.medium {\r\n  height: 32px !important;\r\n}\r\nbutton.small {\r\n  height: 28px !important;\r\n}\r\nbutton.xlarge span {\r\n  font-size: 16px !important;\r\n}\r\nbutton.large span {\r\n  font-size: 16px !important;\r\n}\r\nbutton.medium span {\r\n  font-size: 16px !important;\r\n}\r\nbutton.small span {\r\n  font-size: 14px !important;\r\n}\r\nbutton[class*='-ico'] {\r\n  border: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  background-size: 100%;\r\n}\r\nbutton[class*='-line'] {\r\n  border: 1px solid var(--border);\r\n  padding: 0 24px;\r\n  height: 32px;\r\n}\r\nbutton[class*='-txt'] {\r\n  border: 0;\r\n  padding: 0;\r\n  gap: 4px;\r\n  height: auto !important;\r\n}\r\nbutton[class*='-txt'] span {\r\n  color: var(--primary);\r\n  font-weight: 400;\r\n}\r\nbutton[class*='-txt']:hover span,\r\nbutton[class*='-txt']:active span {\r\n  font-weight: 500;\r\n}\r\nbutton[class*='-txt'].medium span {\r\n  font-size: 14px !important;\r\n}\r\nbutton[class*='-line'] span {\r\n  color: var(--dark-navy);\r\n  font-size: 16px;\r\n}\r\nbutton[class*='-line']:hover,\r\nbutton[class*='-line']:active {\r\n  background: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\nbutton[class*='-line']:hover span,\r\nbutton[class*='-line']:active span {\r\n  color: var(--gray-00);\r\n}\r\n.community .btn-area {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex: 1;\r\n}\r\n.btn-basic.bg-gray60 {\r\n  border-color: var(--gray-60) !important;\r\n}\r\n@media screen and (max-width: 732px) {\r\n  button.xlarge {\r\n    height: 32px !important;\r\n  }\r\n  button.xlarge span {\r\n    font-size: 14px !important;\r\n  }\r\n  button.large {\r\n    height: 32px !important;\r\n  }\r\n  button.large span {\r\n    font-size: 14px !important;\r\n  }\r\n}\r\n\r\n/* scrollbar */\r\n.community *::-webkit-scrollbar,\r\n.community *::-webkit-scrollbar,\r\n.community *::-webkit-scrollbar {\r\n  width: 12px;\r\n  height: 12px;\r\n}\r\n.community *::-webkit-scrollbar-thumb,\r\n.community *::-webkit-scrollbar-thumb,\r\n.community *::-webkit-scrollbar-thumb {\r\n  background-color: var(--gray-20);\r\n  border: 3px solid transparent;\r\n}\r\n\r\n/* etc */\r\n.community .popup-etc {\r\n  top: 24px;\r\n  right: 0;\r\n  width: max-content;\r\n  box-shadow: var(--shadow-04);\r\n  filter: none;\r\n}\r\n.community .popup-etc li {\r\n  padding: 2px 0;\r\n}\r\n.community .popup-etc li:first-child {\r\n  padding-bottom: 0;\r\n}\r\n.community .popup-etc li:last-child {\r\n  padding-top: 0;\r\n}\r\n.community .popup-etc li button {\r\n  /* width: auto !important; */\r\n  height: auto !important;\r\n  border: 0 !important;\r\n  background-size: 24px !important;\r\n  background-position: 12px center !important;\r\n  padding: 3px 16px 2px 45px !important;\r\n  border-radius: 0;\r\n  justify-content: flex-start;\r\n}\r\n.community .popup-etc li button.btn-edit-g {\r\n  background: url('../img/icon_pen.svg') no-repeat center center;\r\n}\r\n.community .popup-etc li button.btn-delete-gr {\r\n  background: url('../img/icon_delete.svg') no-repeat center center;\r\n}\r\n.community .popup-etc li button:focus {\r\n  background-color: #e6f0ff;\r\n}\r\n.community .popup-etc li button.btn-edit-g:focus,\r\n.community .popup-etc li button.btn-edit-g:hover {\r\n  background: url('../img/icon_pen_primary.svg') no-repeat center;\r\n}\r\n.community .popup-etc li button.btn-delete-gr:focus,\r\n.community .popup-etc li button.btn-delete-gr:hover {\r\n  background: url('../img/icon_delete_primary.svg') no-repeat center;\r\n}\r\n.community .popup-etc li button:focus span,\r\n.community .popup-etc li button:hover span {\r\n  font-weight: 700;\r\n  color: #19181a;\r\n}\r\n.community .popup-etc li button:focus {\r\n  background-color: #e6f0ff !important;\r\n  border-radius: 0;\r\n}\r\n.community .popup-etc li button:hover {\r\n  background-color: #e6f0ff !important;\r\n  border-radius: 0;\r\n}\r\n#wrap.page-market.community .btn-login:hover,\r\n#wrap.page-market.community .btn-login:active {\r\n  background: #0050b8;\r\n}\r\n#wrap.page-market.community .btn-login:active {\r\n  border-color: #003876;\r\n  background-color: #003876;\r\n}\r\n\r\n/* etc - 블라인드 내글 관련 */\r\n.txt-info.blind {\r\n  display: flex;\r\n  margin: 0;\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n  color: #f55547 !important;\r\n}\r\n.txt-info.blind:before {\r\n  content: '';\r\n  width: 20px;\r\n  height: 20px;\r\n  background: url('../img/icon_error.svg') no-repeat center -1px;\r\n  background-size: 100%;\r\n  flex: none;\r\n}\r\n.community .area-result .item-list.view > li .item-info-top .txt-info.blind {\r\n  margin-top: -12px;\r\n}\r\n@media screen and (max-width: 499px) {\r\n  .community .area-result .item-list.view > li .item-info-top .txt-info.blind {\r\n    margin-bottom: 4px;\r\n  }\r\n}\r\n\r\n/* Community - main */\r\n#wrap.page-market.community {\r\n  overflow-x: unset;\r\n}\r\n#wrap.page-market.community > .container .content {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  gap: 40px;\r\n  background: #fff;\r\n  padding: 0 40px;\r\n  width: calc(100% - 80px);\r\n  max-width: 1530px;\r\n  margin: 0 auto 160px;\r\n}\r\n#wrap.page-market.community > .container .content .content-center {\r\n  flex: 1;\r\n  width: calc(100% - 400px);\r\n}\r\n/* Community - main - 검색영역 */\r\n#wrap.page-market.community > .container .content .area-search h2 {\r\n  font-size: 36px;\r\n  letter-spacing: -0.035em;\r\n  color: var(--secondary);\r\n}\r\n#wrap.page-market.community > .container .content .area-search .searcharea {\r\n  margin: 30px auto 0;\r\n  border: 1px solid var(--border);\r\n  box-shadow: var(--shadow-01);\r\n}\r\n#wrap.page-market.community > .container .content .area-search .searcharea .searchinput {\r\n  width: calc(100% - 40px);\r\n}\r\n#wrap.page-market.community > .container .content .area-search .searcharea button.btn-search {\r\n  background: url('../img/icon_search.svg') no-repeat center center;\r\n}\r\n#wrap.page-market.community > .container .content .area-search .searcharea .select.active ul {\r\n  margin: 2px 0 0 -32px;\r\n  padding: 2px 0;\r\n  border-radius: 8px;\r\n}\r\n#wrap.page-market.community > .container .content .area-search .searcharea .select.active ul li:active {\r\n  font-weight: 500;\r\n}\r\n\r\n/* Community - main - 리스트영역 */\r\n.community .area-result {\r\n  /* max-width: 1082px; */\r\n  max-width: unset;\r\n}\r\n.community .solution-area {\r\n  margin-top: 0;\r\n}\r\n.area-result .item-list {\r\n  grid-template-columns: repeat(auto-fill, minmax(350px, auto));\r\n  gap: 16px;\r\n}\r\n.community .solution-area .item-list-top {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  width: 100%;\r\n}\r\n.community .solution-area .item-list-top .left,\r\n.community .solution-area .item-list-top .right {\r\n  display: flex;\r\n  gap: 24px;\r\n}\r\n.community .solution-area .item-list-top .left + .right {\r\n  width: auto;\r\n}\r\n.community .solution-area .item-list-top .right {\r\n  position: relative;\r\n  width: 100%;\r\n  justify-content: flex-end;\r\n}\r\n.community .area-result .solution-area .item-list-top .select {\r\n  font-size: 0.813rem;\r\n  color: var(--gray-30);\r\n}\r\n.community .area-result .solution-area .item-list-top .select .selected {\r\n  gap: 8px;\r\n}\r\n.community .area-result .solution-area .item-list-top .select .selected .arrow {\r\n  background: url('../img/icon_arrow_gray30.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.community .area-result .solution-area .item-list-top .select.active .selected .arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.community .area-result .solution-area .item-list-top .select.active ul {\r\n  margin-top: 8px;\r\n  border: 0;\r\n  border-radius: 8px;\r\n  min-width: 128px;\r\n  width: auto !important;\r\n}\r\n.community .area-result .solution-area .item-list-top .select ul li {\r\n  color: var(--secondary);\r\n}\r\n.community .area-result .solution-area .item-list-top .select ul li:active {\r\n  font-weight: 500;\r\n}\r\n.community .solution-area .top .btn-basic {\r\n  border-color: var(--primary) !important;\r\n  background-color: var(--primary) !important;\r\n}\r\n.community .solution-area .top .btn-basic span {\r\n  color: var(--gray-00);\r\n}\r\n.community .solution-area .top .btn-basic:hover {\r\n  background-color: var(--primary-hover) !important;\r\n  border-color: var(--primary-hover) !important;\r\n}\r\n.community .solution-area .top .btn-basic:active {\r\n  background-color: var(--primary-active) !important;\r\n  border-color: var(--primary-active) !important;\r\n}\r\n.community .solution-area .top button.large {\r\n  min-width: 140px;\r\n}\r\n.community .area-result .item-list {\r\n  width: calc(100% - 20px);\r\n  grid-template-columns: repeat(3, 1fr);\r\n  /* grid-template-columns: repeat(auto-fill, minmax(331px, auto)); */\r\n  gap: 16px;\r\n}\r\n.community .area-result .item-list > li {\r\n  height: 360px;\r\n  box-shadow: var(--shadow-02);\r\n  border: 0;\r\n  max-width: 350px;\r\n}\r\n.community .area-result .item-list > li .item-info {\r\n  position: relative;\r\n}\r\n.community .area-result .item-list > li .item-info:hover::before,\r\n.community .area-result .item-list > li .item-info:active::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 1px solid #909fb7;\r\n  border-radius: 8px;\r\n}\r\n.community .area-result .item-list > li.set-blue .item-info:hover::before,\r\n.community .area-result .item-list > li.set-blue .item-info:active::before {\r\n  border-color: var(--point-01);\r\n}\r\n.community .area-result .item-list > li.set-teal .item-info:hover::before,\r\n.community .area-result .item-list > li.set-teal .item-info:active::before {\r\n  border-color: var(--point-02);\r\n}\r\n.community .area-result .item-list > li.set-yellow .item-info:hover::before,\r\n.community .area-result .item-list > li.set-yellow .item-info:active::before {\r\n  border-color: var(--point-03);\r\n}\r\n.community .area-result .item-list > li.set-magenta .item-info:hover::before,\r\n.community .area-result .item-list > li.set-magenta .item-info:active::before {\r\n  border-color: var(--point-04);\r\n}\r\n.community .area-result .item-list > li.set-navy .item-info:hover::before,\r\n.community .area-result .item-list > li.set-navy .item-info:active::before {\r\n  border-color: var(--point-05);\r\n}\r\n.community .area-result .item-list > li.set-green .item-info:hover::before,\r\n.community .area-result .item-list > li.set-green .item-info:active::before {\r\n  border-color: var(--point-06);\r\n}\r\n.community .area-result .item-list > li .item-info:hover,\r\n.community .area-result .item-list > li .item-info:active {\r\n  background: #ffffff;\r\n}\r\n.community .area-result .item-list > li.set-blue .item-info:hover,\r\n.community .area-result .item-list > li.set-blue .item-info:active {\r\n  background: #f9fafd;\r\n}\r\n.community .area-result .item-list > li.set-teal .item-info:hover,\r\n.community .area-result .item-list > li.set-teal .item-info:active {\r\n  background: #f9fffe;\r\n}\r\n.community .area-result .item-list > li.set-yellow .item-info:hover,\r\n.community .area-result .item-list > li.set-yellow .item-info:active {\r\n  background: #fffffc;\r\n}\r\n.community .area-result .item-list > li.set-magenta .item-info:hover,\r\n.community .area-result .item-list > li.set-magenta .item-info:active {\r\n  background: #fffbfc;\r\n}\r\n.community .area-result .item-list > li.set-navy .item-info:hover,\r\n.community .area-result .item-list > li.set-navy .item-info:active {\r\n  background: #ffffff;\r\n}\r\n.community .area-result .item-list > li.set-green .item-info:hover,\r\n.community .area-result .item-list > li.set-green .item-info:active {\r\n  background: #fcfffb;\r\n}\r\n.community .area-result .item-list > li .item-info {\r\n  position: relative;\r\n  display: block;\r\n  height: calc(100% - 48px);\r\n  padding: 24px;\r\n}\r\n.community .area-result .item-list > li .item-info-top {\r\n  display: block;\r\n  margin-top: 24px;\r\n  padding: 0;\r\n  overflow: unset;\r\n}\r\n.community .area-result .item-list > li .item-info-top .cate {\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  padding: 6px 16px 5px;\r\n  border-radius: 4px 0 4px 0;\r\n  background: #909fb7;\r\n  width: auto;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: #fff;\r\n  line-height: 1.1;\r\n}\r\n.community .area-result .item-list > li {\r\n  background: #f1f3f6;\r\n}\r\n.community .area-result .item-list > li.set-blue {\r\n  background: var(--point-01-bg);\r\n}\r\n.community .area-result .item-list > li.set-teal {\r\n  background: var(--point-02-bg);\r\n}\r\n.community .area-result .item-list > li.set-yellow {\r\n  background: var(--point-03-bg);\r\n}\r\n.community .area-result .item-list > li.set-magenta {\r\n  background: var(--point-04-bg);\r\n}\r\n.community .area-result .item-list > li.set-navy {\r\n  background: var(--point-05-bg);\r\n}\r\n.community .area-result .item-list > li.set-green {\r\n  background: var(--point-06-bg);\r\n}\r\n.community .area-result .item-list > li.set-blue .item-info-top .cate {\r\n  background: var(--point-01);\r\n}\r\n.community .area-result .item-list > li.set-teal .item-info-top .cate {\r\n  background: var(--point-02);\r\n}\r\n.community .area-result .item-list > li.set-yellow .item-info-top .cate {\r\n  background: var(--point-03);\r\n}\r\n.community .area-result .item-list > li.set-magenta .item-info-top .cate {\r\n  background: var(--point-04);\r\n}\r\n.community .area-result .item-list > li.set-navy .item-info-top .cate {\r\n  background: var(--point-05);\r\n}\r\n.community .area-result .item-list > li.set-green .item-info-top .cate {\r\n  background: var(--point-06);\r\n}\r\n.community .area-result .item-list > li .item-info-top .icon-area {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n}\r\n.community .area-result .item-list > li .item-info-top i {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n.community .area-result .item-list > li .item-info-top .keyword {\r\n  width: 100%;\r\n  height: 19.5px;\r\n  margin-bottom: 8px;\r\n  display: block;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  color: var(--primary);\r\n  z-index: 1;\r\n  position: relative;\r\n}\r\n.community .area-result .item-list > li .item-info-top .keyword span {\r\n  cursor: pointer;\r\n}\r\n.community .area-result .item-list > li .item-info-top .keyword span:hover {\r\n  font-weight: 500;\r\n}\r\n.community .area-result .item-list > li .item-info-top .keyword span + span {\r\n  margin-left: 16px;\r\n}\r\n.community .area-result .item-list > li .item-info-cont {\r\n  min-height: 62%;\r\n}\r\n.community .area-result .item-list > li .item-info-cont .tit {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  color: var(--gray-90);\r\n  line-height: 1.4;\r\n  height: 56px;\r\n  margin-bottom: 16px;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  white-space: normal;\r\n  text-overflow: ellipsis;\r\n}\r\n.community .area-result .item-list:not(.view) > li .item-info-cont .cont {\r\n  font-size: 0.813rem;\r\n  color: var(--secondary);\r\n  line-height: 1.6;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  white-space: normal;\r\n  text-overflow: ellipsis;\r\n  word-break: break-all;\r\n  word-wrap: break-word;\r\n}\r\n.community .area-result .item-list > li .item-info-bottom {\r\n  position: absolute;\r\n  bottom: 24px;\r\n  display: flex;\r\n  width: calc(100% - 48px);\r\n  gap: 8px;\r\n  z-index: 1;\r\n}\r\n.community .area-result .item-list > li .user-photo {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n}\r\n.community .area-result .item-list > li .user-photo > span {\r\n  font-size: 1.5rem;\r\n  color: #fff;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--gray-20);\r\n  border-radius: 50%;\r\n}\r\n.community .area-result .item-list > li .user-photo img {\r\n  border-radius: 50%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n.community .area-result .item-list > li .user-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  flex: 1;\r\n}\r\n.community .area-result .item-list > li .name {\r\n  display: flex;\r\n  gap: 4px;\r\n  font-size: 0.813rem;\r\n  font-weight: 500;\r\n  line-height: 1.5;\r\n  color: var(--secondary);\r\n}\r\n.community .area-result .item-list > li .etc {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.community .area-result .item-list > li .etc > li {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n.community .area-result .item-list > li .etc > li span {\r\n  font-size: 0.75rem;\r\n  color: var(--gray-30);\r\n  background-size: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n.community .area-result .item-list > li .etc > li span:before {\r\n  content: '';\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n.community .area-result .item-list > li .etc > li span.date:before {\r\n  background: url('../img/icon_date.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.community .area-result .item-list > li .etc > li span.view:before {\r\n  background: url('../img/icon_view.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.community .area-result .item-list > li .etc > li span.like:before {\r\n  background: url('../img/icon_like.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n\r\n/* Community - main - floating */\r\n.community .content-left-float {\r\n  position: relative;\r\n  width: 184px;\r\n  z-index: 2;\r\n}\r\n.community .content-right-float {\r\n  position: relative;\r\n  width: 184px;\r\n  z-index: 2;\r\n}\r\n.community .content-left-float .inner,\r\n.community .content-right-float .inner {\r\n  position: absolute;\r\n  top: 335px;\r\n  width: 184px;\r\n}\r\n.community .float-box {\r\n  position: relative;\r\n  padding: 24px 16px;\r\n  background: var(--gray-00);\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n}\r\n.community .float-box:not(.banner):hover {\r\n  box-shadow: var(--shadow-02);\r\n  border-radius: 8px;\r\n}\r\n.community .float-box-wrap:hover {\r\n  box-shadow: var(--shadow-02);\r\n  border-radius: 8px;\r\n}\r\n.community .float-box-wrap:hover .float-box:hover {\r\n  box-shadow: none;\r\n  border-radius: none;\r\n}\r\n.community .float-box-wrap .float-box {\r\n  border-radius: 0;\r\n}\r\n.community .float-box-wrap .float-box:first-child {\r\n  border-radius: 8px 8px 0 0;\r\n}\r\n.community .float-box-wrap .float-box:last-child {\r\n  border-radius: 0 0 8px 8px;\r\n}\r\n.community .float-box-wrap .float-box + .float-box {\r\n  border-top: 0;\r\n}\r\n.community .float-box > .icon-info {\r\n  position: absolute;\r\n  top: 22px;\r\n  right: 16px;\r\n  display: none;\r\n}\r\n.community .float-box:hover > .icon-info {\r\n  display: block;\r\n}\r\n.community .float-box > .tit {\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  color: var(--gray-30);\r\n  line-height: 1.5;\r\n  margin-bottom: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n.community .float-box > .tit::before {\r\n  content: '';\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n.community .float-box.best > .tit::before {\r\n  background: url('../img/icon_thumb.svg');\r\n  background-size: 100%;\r\n}\r\n.community .float-box.topwriter > .tit::before {\r\n  background: url('../img/icon_topstar.svg');\r\n  background-size: 100%;\r\n}\r\n.community .float-box.tag > .tit::before {\r\n  background: url('../img/icon_tag.svg');\r\n  background-size: 100%;\r\n}\r\n.community .float-box .list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n.community .float-box .list > li > a {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n.community .float-box .list > li > a p {\r\n  font-size: 0.75rem;\r\n  color: var(--secondary);\r\n}\r\n.community .float-box .list > li > a:hover p {\r\n  font-weight: 700 !important;\r\n}\r\n.community .float-box .list > li > a .num {\r\n  color: var(--gray-30);\r\n}\r\n.community .float-box .list > li > a .tit {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  flex: 1;\r\n}\r\n.community .float-box .list > li > a .like-num {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.688rem;\r\n  font-weight: 500;\r\n  color: var(--gray-30);\r\n  width: 32px;\r\n  min-width: 32px;\r\n  height: 16px;\r\n  background: #f0f2f4;\r\n  border-radius: 25px;\r\n}\r\n.community .float-box.tag .list {\r\n  gap: 8px;\r\n}\r\n.community .float-box .list > li > a .tit.keyword {\r\n  padding: 4px 8px 3px;\r\n  background: var(--sky);\r\n  border-radius: 25px;\r\n  flex: none;\r\n  line-height: normal;\r\n  color: var(--primary);\r\n}\r\n\r\n.community .float-box .page {\r\n  margin-top: 40px;\r\n  margin-bottom: -8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.community .float-box .page p {\r\n  font-size: 0.75rem;\r\n  color: var(--secondary);\r\n  font-weight: 500;\r\n}\r\n.community .float-box .page a {\r\n  width: 20px;\r\n  height: 20px;\r\n  background: url('../img/icon_arrow.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.community .float-box .page a.btn-next {\r\n  transform: scaleX(-1);\r\n}\r\n.community .float-box.banner {\r\n  margin-bottom: 20px;\r\n  padding: 0;\r\n  border: 0;\r\n  background: none;\r\n  border-radius: 0;\r\n}\r\n.community .float-box.banner .banner-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  overflow: hidden;\r\n  width: 184px;\r\n  height: 250px;\r\n  border: 1px solid var(--gray-00);\r\n  border-radius: 8px;\r\n}\r\n.community .float-box.banner .banner-list > li {\r\n  width: 100%;\r\n  height: 100%;\r\n  flex-shrink: 0;\r\n}\r\n.community .float-box.banner .banner-list img {\r\n  border-radius: 8px;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n.community .float-box.banner .slide-pagenation {\r\n  gap: 12px;\r\n  margin-top: 9px;\r\n}\r\n\r\n@media screen and (max-width: 1562px) {\r\n  #wrap.page-market.community > .container .content {\r\n    gap: 16px;\r\n  }\r\n  .community .area-result .item-list {\r\n    /* grid-template-columns: repeat(auto-fill, minmax(386.5px, auto)); */\r\n    grid-template-columns: repeat(2, 49.2%);\r\n  }\r\n  .community .area-result .item-list > li {\r\n    max-width: 100%;\r\n  }\r\n}\r\n@media screen and (max-width: 1278px) {\r\n  #wrap.page-market.community > .container {\r\n    min-height: calc(100vh - 101px);\r\n  }\r\n  .community .area-result .item-list {\r\n    grid-template-columns: 100%;\r\n    max-width: 694px;\r\n    /* width: calc(100% - 20px); */\r\n  }\r\n  /* .community .area-result .item-list > li {\r\n    max-width: calc(100% - 20px);\r\n  } */\r\n  .community .content-right-float,\r\n  .community .content-left-float {\r\n    display: none;\r\n  }\r\n  .community .solution-area {\r\n    max-width: 692px;\r\n    margin: 0 auto;\r\n  }\r\n  #wrap.page-market.community > .container .content .area-search .searcharea {\r\n    width: calc(100% - 54px);\r\n    max-width: 634px;\r\n  }\r\n  #wrap.page-market.community > .container .content {\r\n    padding: 0 20px;\r\n    width: calc(100% - 40px);\r\n  }\r\n}\r\n@media screen and (max-width: 733px) {\r\n  #wrap.page-market.community > .container .content .area-search h2 {\r\n    font-size: 2rem;\r\n    text-align: left;\r\n    width: 100%;\r\n  }\r\n  #wrap.page-market.community > .container .content .area-search .searcharea {\r\n    margin-top: 46px;\r\n  }\r\n  #wrap.page-market > .container .content .area-search {\r\n    margin-bottom: 24px;\r\n  }\r\n  .community .solution-area .top button.large.m-mt-26 {\r\n    margin-top: 0 !important;\r\n  }\r\n}\r\n@media screen and (max-width: 732px) {\r\n  .community .area-result .item-list > li {\r\n    height: 306px;\r\n  }\r\n  #wrap.page-market.community > .container .content .content-center {\r\n    width: 100%;\r\n  }\r\n}\r\n@media screen and (max-width: 390px) {\r\n  .community .solution-area .item-list-top .left,\r\n  .community .solution-area .item-list-top .right {\r\n    gap: 10px;\r\n  }\r\n}\r\n@media screen and (max-width: 320px) {\r\n  .community .solution-area .item-list-top {\r\n    gap: 10px;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n/* Community - detail */\r\n#wrap.page-market.community.detail > .container {\r\n  background: var(--gradation-01);\r\n}\r\n#wrap.page-market.community.detail > .container .content {\r\n  margin-top: 80px;\r\n  border-top: 0;\r\n  max-width: 1230px;\r\n  background: transparent;\r\n}\r\n\r\n/* Community - detail - 댓글뷰 상세화면 */\r\n#wrap.page-market.community.detail > .container.set-no {\r\n  background: #f1f3f6;\r\n}\r\n#wrap.page-market.community.detail > .container.set-blue {\r\n  background: var(--point-01-bg);\r\n}\r\n#wrap.page-market.community.detail > .container.set-teal {\r\n  background: #f9fffe;\r\n}\r\n#wrap.page-market.community.detail > .container.set-yellow {\r\n  background: #fffffc;\r\n}\r\n#wrap.page-market.community.detail > .container.set-magenta {\r\n  background: #fffbfc;\r\n}\r\n#wrap.page-market.community.detail > .container.set-navy {\r\n  background: var(--point-05-bg);\r\n}\r\n#wrap.page-market.community.detail > .container.set-green {\r\n  background: #fcfffb;\r\n}\r\n.community.detail .area-result .item-list.view {\r\n  grid-template-columns: repeat(auto-fill, minmax(100%, auto));\r\n  width: auto !important;\r\n}\r\n.community.detail .area-result .item-list.view > li {\r\n  max-width: 100%;\r\n  height: auto;\r\n  background: var(--gray-00) !important;\r\n}\r\n.community .area-result .item-list.view > li a:hover,\r\n.community .area-result .item-list.view > li a:active {\r\n  background: none !important;\r\n}\r\n.community .area-result .item-list.view > li a:hover::before,\r\n.community .area-result .item-list.view > li a:active::before {\r\n  content: none !important;\r\n}\r\n.community .area-result .item-list.view > li .item-info:hover,\r\n.community .area-result .item-list.view > li .item-info:active {\r\n  background: none !important;\r\n}\r\n.community .area-result .item-list.view > li .item-info:hover::before,\r\n.community .area-result .item-list.view > li .item-info:active::before {\r\n  content: none !important;\r\n}\r\n.community .area-result .item-list.view > li .item-info {\r\n  padding: 0;\r\n  height: auto;\r\n  border-radius: 8px;\r\n}\r\n.community .area-result .item-list.view > li .item-info-top {\r\n  margin-top: 0;\r\n  padding: 40px 32px 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.community .area-result .item-list.view .item-info-top .tit {\r\n  font-size: 1.625rem;\r\n  font-weight: 700;\r\n  color: var(--gray-90);\r\n  line-height: 1.5;\r\n  letter-spacing: -0.04em;\r\n  padding: 0;\r\n}\r\n.community .area-result .item-list.view > li .item-info-top .icon-area {\r\n  position: relative;\r\n  top: unset;\r\n  right: unset;\r\n}\r\n.community .area-result .item-list.view > li .item-info-top i {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n.area-result .solution-area .item-list.view .top {\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  margin-bottom: 0;\r\n}\r\n.area-result .solution-area .item-list.view .top .left {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n.area-result .solution-area .item-list.view .top .right {\r\n  position: relative;\r\n}\r\n.area-result .solution-area .item-list.view .btn.btn-etc {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.area-result .solution-area .item-list.view .bottom {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n}\r\n.area-result .solution-area .item-list.view .bottom .left {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n.area-result .solution-area .item-list.view .item-info-cont {\r\n  padding: 16px 32px 80px;\r\n}\r\n.area-result .solution-area .item-list.view .item-info-cont > * + * {\r\n  margin-top: 24px;\r\n}\r\n.area-result .solution-area .item-list.view .item-info-cont .keyword {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n.area-result .solution-area .item-list.view .item-info-cont .keyword span {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  color: var(--primary);\r\n  line-height: 1.42;\r\n  background: var(--sky);\r\n  padding: 0 12px;\r\n  height: 28px;\r\n  border-radius: 25px;\r\n  cursor: pointer;\r\n}\r\n.area-result .solution-area .item-list.view .item-info-cont .keyword span:hover {\r\n  background: var(--primary);\r\n  color: var(--gray-00);\r\n}\r\n.area-result .solution-area .item-list.view .item-info-cont .keyword span:before {\r\n  content: '#';\r\n}\r\n.area-result .solution-area .item-list.view .item-info-cont .cont {\r\n  font-size: 0.875rem;\r\n  line-height: 1.7;\r\n}\r\n.item-list.view .item-info-cont .cont > * + * {\r\n  margin-top: 24px;\r\n}\r\n.item-list.view li .img-wrap {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n  height: auto;\r\n  background: none;\r\n  border-radius: 0;\r\n}\r\n.item-list.view li .img-wrap img {\r\n  object-fit: cover;\r\n  border-radius: 0;\r\n  height: 248px;\r\n  width: auto;\r\n}\r\n.area-result .solution-area .item-list.view .item-info-cont > .filelist-wrap {\r\n  margin-top: 56px;\r\n}\r\n.community .area-result .item-list > li .item-info-cont .filelist-wrap .tit {\r\n  font-size: 0.875rem;\r\n  line-height: 1.4;\r\n  font-weight: 700;\r\n  height: auto;\r\n  margin-bottom: 8px;\r\n}\r\n.community .filelist {\r\n  margin: 0;\r\n}\r\n.community .filelist li {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  margin-bottom: 8px;\r\n}\r\n.community .item-list.view .filelist li {\r\n  margin-left: 24px;\r\n}\r\n.community .filelist li span {\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  background: none;\r\n  padding-left: 0;\r\n  position: relative;\r\n}\r\n.community .filelist li span:before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -24px;\r\n  top: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: url('../img/icon_file.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.community .filelist li .btn-delete {\r\n  display: inline;\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-left: 0;\r\n  background: url('../img/icon_delete_gray20.svg') no-repeat center 1px;\r\n  background-size: 100%;\r\n}\r\n.community .area-result .item-list.view > li {\r\n  box-shadow: var(--shadow-06);\r\n}\r\n.community .area-result .item-list.view > li .item-info-bottom {\r\n  position: relative;\r\n  bottom: unset;\r\n  padding: 0 32px 32px;\r\n  width: calc(100% - 64px);\r\n}\r\n.community .area-result .item-list.view > li .item-info-bottom .btn-area {\r\n  justify-content: flex-end;\r\n}\r\n.community .area-result .item-list.view > li .btn-line.toggle {\r\n  gap: 8px;\r\n  padding: 0;\r\n  width: 94px;\r\n}\r\n.community .area-result .item-list.view > li .btn-line.toggle.large {\r\n  height: 40px !important;\r\n}\r\n.community .area-result .item-list.view > li .btn-line.toggle span {\r\n  color: var(--dark-navy);\r\n  font-size: 16px !important;\r\n}\r\n.community .area-result .item-list.view > li .btn-line.toggle span.num {\r\n  font-weight: 400;\r\n  min-width: 24px;\r\n}\r\n.community .area-result .item-list.view > li .btn-line.toggle .icon-like {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n.community .area-result .item-list.view > li .btn-line.toggle:hover,\r\n.community .area-result .item-list.view > li .btn-line.toggle:active,\r\n.community .area-result .item-list.view > li .btn-line.toggle.active {\r\n  background: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n.community .area-result .item-list.view > li .btn-line.toggle:hover span,\r\n.community .area-result .item-list.view > li .btn-line.toggle:active span,\r\n.community .area-result .item-list.view > li .btn-line.toggle.active span {\r\n  color: var(--gray-00);\r\n}\r\n.community .area-result .item-list.view > li .btn-line.toggle:hover .icon-like,\r\n.community .area-result .item-list.view > li .btn-line.toggle:active .icon-like,\r\n.community .area-result .item-list.view > li .btn-line.toggle.active .icon-like {\r\n  background: url('../img/icon_like_gray00.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n\r\n/* Community - detail - 댓글 리스트 */\r\n.comment-area {\r\n  margin-top: 90px;\r\n}\r\n.community .solution-area .comment-area .item-list-top {\r\n  margin-bottom: 2px;\r\n}\r\n.m-m10 .item-list-top,\r\n.community .solution-area .m-m10 .item-list-top {\r\n  margin: 0 10px;\r\n  width: calc(100% - 20px);\r\n}\r\n.community .solution-area .comment-area .item-list-top .num {\r\n  font-size: 0.875rem;\r\n  line-height: 1.7;\r\n  color: var(--secondary);\r\n}\r\n.community .solution-area .comment-area .item-list-top .num span {\r\n  margin-left: 8px;\r\n}\r\n.community .area-result .comment-area .item-list {\r\n  gap: 8px;\r\n}\r\n.community .area-result .comment-area .item-list > li:not(.best) {\r\n  box-shadow: var(--shadow-05);\r\n}\r\n.community .area-result .comment-area .item-list.view > li .item-info-top {\r\n  padding: 24px 32px 0;\r\n  border-bottom: 0;\r\n}\r\n.area-result .solution-area .comment-area .item-list.view > li .item-info-top .bottom {\r\n  align-items: flex-start;\r\n}\r\n.community .area-result .comment-area .item-list.view > li .item-info-cont {\r\n  padding: 16px 32px 24px 80px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 32px;\r\n}\r\n.community .area-result .comment-area .item-list.view > li .item-info-cont .left {\r\n  flex: 1;\r\n}\r\n.area-result .solution-area .comment-area .item-list.view .item-info-cont .cont {\r\n  line-height: 1.35;\r\n}\r\n.area-result .solution-area .comment-area .item-list.view .item-info-cont > * + * {\r\n  margin-top: 0;\r\n}\r\n.community .area-result .comment-area .item-list.view > li .item-info-top .icon-area + .user-photo {\r\n  margin-left: -8px;\r\n}\r\n.community .area-result .comment-area .item-list.view > li .btn-line.toggle {\r\n  width: 62px;\r\n}\r\n.community .area-result .comment-area .item-list.view > li .btn-line.toggle span {\r\n  font-size: 12px !important;\r\n}\r\n.community .area-result .comment-area .item-list.view > li .btn-line.toggle span.num {\r\n  min-width: 14px;\r\n}\r\n.comment-area .list-more {\r\n  margin: 22px auto 0;\r\n  padding-bottom: 6px;\r\n}\r\n.comment-area .list-more .icon-arrow-small {\r\n  width: 17px;\r\n}\r\n.comment-area .filelist-wrap,\r\n.comment-area .filelist {\r\n  margin-top: 16px;\r\n}\r\n\r\n/* Community - detail - 댓글 작성 */\r\n.community .comment-write-area {\r\n  margin: 16px 0 0;\r\n}\r\n.m-m10 .comment-write-area {\r\n  margin: 16px 10px 10px;\r\n}\r\n.comment-write-area .info-txt-box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  min-height: 200px;\r\n  font-size: 0.875rem;\r\n  text-align: center;\r\n  line-height: 1.7;\r\n  color: var(--secondary);\r\n  border: 1px solid var(--border);\r\n  border-radius: 4px;\r\n  background: var(--gray-00);\r\n}\r\n.comment-write-area .info-txt-box strong {\r\n  font-weight: 500;\r\n}\r\n.community .page-bottom {\r\n  margin-top: 80px;\r\n  padding-top: 16px;\r\n  border-top: 1px solid var(--border);\r\n}\r\n.community .m-m10 .page-bottom {\r\n  margin: 80px 10px 10px;\r\n}\r\n.write-box .top,\r\n.area-result .solution-area .write-box .top {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n  margin-bottom: 0;\r\n}\r\n.write-box .top + .filelist,\r\n.write-box .top + .filelist-wrap {\r\n  margin-top: 16px;\r\n}\r\n.community .write-box .filelist {\r\n  margin-left: 24px;\r\n}\r\n.write-box .top p {\r\n  font-size: 0.875rem;\r\n  line-height: 1.1;\r\n  color: var(--gray-20);\r\n}\r\n.write-box .filearea {\r\n  border-bottom: 1px solid var(--border);\r\n  border-left: 1px solid var(--border);\r\n  border-right: 1px solid var(--border);\r\n  border-radius: 0 0 4px 4px;\r\n  background: var(--gray-00);\r\n  padding: 16px;\r\n}\r\n.write-box .editarea {\r\n  border: 1px solid var(--border);\r\n  border-radius: 4px 4px 0 0;\r\n  background: var(--gray-00);\r\n  padding: 0;\r\n}\r\n.write-box .editarea textarea {\r\n  padding: 16px 16px 0;\r\n  height: 230px;\r\n  border: 0;\r\n  width: calc(100% - 32px);\r\n  font-size: 0.875rem;\r\n  line-height: 1.7;\r\n}\r\n.write-box .editarea .ck-editor__editable:not(td) {\r\n  height: 594px;\r\n}\r\n.community .write-box .btn-area {\r\n  margin-top: 12px;\r\n  justify-content: flex-end;\r\n}\r\n.comment-write-area .write-box:hover .editarea,\r\n.comment-write-area .write-box:active .editarea {\r\n  border-top-color: var(--primary);\r\n  border-left-color: var(--primary);\r\n  border-right-color: var(--primary);\r\n}\r\n.comment-write-area .write-box:hover .filearea,\r\n.comment-write-area .write-box:active .filearea {\r\n  border-bottom-color: var(--primary);\r\n  border-left-color: var(--primary);\r\n  border-right-color: var(--primary);\r\n}\r\n\r\n@media screen and (max-width: 1278px) {\r\n  .community.detail .solution-area {\r\n    max-width: 100%;\r\n  }\r\n  #wrap.page-market.community.detail > .container .content {\r\n    padding: 0 40px;\r\n    width: calc(100% - 80px);\r\n    margin-top: 40px;\r\n  }\r\n  #wrap.page-market.community.detail > .container .content > div {\r\n    padding: 0;\r\n    width: 100%;\r\n  }\r\n  .community.detail .area-result .item-list {\r\n    max-width: 100%;\r\n  }\r\n}\r\n@media screen and (max-width: 779px) {\r\n  .area-result .solution-area .item-list.view .top .right {\r\n    width: auto;\r\n  }\r\n}\r\n@media screen and (max-width: 732px) {\r\n  #wrap.page-market.community.detail > .container .content {\r\n    margin-bottom: 74px;\r\n  }\r\n  .community .area-result .item-list.view .item-info-top .tit {\r\n    font-size: 1.5rem;\r\n  }\r\n  .area-result .solution-area .item-list.view .item-info-cont {\r\n    padding: 16px 32px 40px;\r\n  }\r\n  .community .area-result .comment-area .item-list.view > li .item-info-cont {\r\n    padding: 16px 32px 24px;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n  }\r\n  .community .area-result .comment-area .item-list.view > li .item-info-cont .btn-area {\r\n    justify-content: flex-end;\r\n  }\r\n  .comment-write-area .info-txt-box {\r\n    min-height: 182px;\r\n  }\r\n  .community .page-bottom {\r\n    padding-top: 40px;\r\n  }\r\n}\r\n@media screen and (max-width: 499px) {\r\n  #wrap.page-market.community.detail > .container .content {\r\n    padding: 0 20px;\r\n    width: calc(100% - 40px);\r\n  }\r\n  .community.detail .area-result div:not(.comment-area) > .item-list.view {\r\n    margin: -40px -20px -10px;\r\n    padding-right: 0 !important;\r\n    width: calc(100% + 20px) !important;\r\n    max-width: calc(100% + 20px) !important;\r\n  }\r\n  .community.detail .area-result div:not(.comment-area) > .item-list.view > li {\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    width: 100%;\r\n  }\r\n  .comment-area {\r\n    margin-top: 10px;\r\n  }\r\n  .community .area-result .comment-area .item-list.view > li .item-info-cont {\r\n    padding: 16px 20px 20px;\r\n  }\r\n  .community .area-result .item-list.view > li .item-info-top {\r\n    padding: 40px 20px 16px;\r\n  }\r\n  .area-result .solution-area .item-list.view .top {\r\n    gap: 0;\r\n  }\r\n  .community .area-result .item-list.view .item-info-top .tit {\r\n    line-height: 1.4;\r\n  }\r\n  .area-result .solution-area .item-list.view .item-info-cont {\r\n    padding: 16px 20px 40px;\r\n  }\r\n  .area-result .solution-area .item-list.view .item-info-cont > .filelist-wrap {\r\n    margin-top: 40px;\r\n  }\r\n  .community .area-result .item-list.view > li .item-info-bottom {\r\n    padding: 0 20px 20px;\r\n    width: calc(100% - 40px);\r\n  }\r\n  .community .area-result .comment-area .item-list.view > li .item-info-top {\r\n    padding: 20px 20px 0;\r\n  }\r\n  .m-m10 .item-list-top,\r\n  .community .solution-area .m-m10 .item-list-top {\r\n    align-items: center;\r\n  }\r\n  .m-m10 .comment-write-area,\r\n  .community .comment-write-area {\r\n    margin-top: 8px;\r\n  }\r\n  .comment-area .list-more {\r\n    margin-top: 10px;\r\n  }\r\n  .comment-write-area .info-txt-box {\r\n    min-height: 114px;\r\n    padding: 16px;\r\n  }\r\n  .write-box .editarea textarea {\r\n    height: 160px;\r\n  }\r\n  .write-box .top,\r\n  .area-result .solution-area .write-box .top {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n  }\r\n  .community .write-box .btn-area {\r\n    margin-top: 8px;\r\n  }\r\n  .write-box .filearea {\r\n    padding: 16px 0 16px 16px;\r\n  }\r\n  .write-box .top + .filelist-wrap {\r\n    max-height: 106px;\r\n    overflow-y: auto;\r\n    padding-right: 10px;\r\n  }\r\n  .community .write-box .filelist {\r\n    padding-right: 8px;\r\n  }\r\n}\r\n\r\n/* Community - detail - 글 작성 */\r\n.community .m-m10 .write-area {\r\n  margin: 12px 10px 10px;\r\n}\r\n.community .write-area {\r\n  margin: 12px 0 0;\r\n}\r\n.community.detail .solution-area .m-m10 .page-info {\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n}\r\n.community.detail .solution-area .page-info {\r\n  margin-bottom: 12px;\r\n}\r\n.community.detail .solution-area .page-info .tit {\r\n  font-size: 1.25rem;\r\n  font-weight: 500;\r\n  color: var(--secondary);\r\n  letter-spacing: -0.04em;\r\n}\r\n.community.detail .solution-area .page-info .tit + .txt {\r\n  margin-top: 16px;\r\n}\r\n.community.detail .solution-area .page-info .txt {\r\n  font-size: 0.813rem;\r\n  line-height: 1.69;\r\n  letter-spacing: -0.04em;\r\n}\r\n.num-bg,\r\n.btn-txt.medium span.num-bg {\r\n  padding: 0 8px;\r\n  min-width: 18px;\r\n  height: 20px;\r\n  background: var(--primary);\r\n  border-radius: 25px;\r\n  font-size: 0.75rem !important;\r\n  font-weight: 500 !important;\r\n  color: var(--gray-00) !important;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.community .write-area .flex-row {\r\n  gap: 34px;\r\n}\r\n.community .write-area .flex-row > .right {\r\n  flex: 1;\r\n}\r\n.community .write-area .flex-row > .left .tit {\r\n  min-width: 122px;\r\n  margin-top: 4px;\r\n  margin-left: 8px;\r\n  font-size: 0.938rem;\r\n  font-weight: 700;\r\n  letter-spacing: -0.04em;\r\n  line-height: 1.3;\r\n  color: var(--secondary);\r\n}\r\n.community .write-area .tagarea {\r\n  border-radius: 4px 4px 0 0;\r\n  background: var(--gray-00);\r\n  padding: 16px;\r\n  height: 128px;\r\n}\r\n.community .write-area .write-box > .shadow-box > div + div {\r\n  border-top: 1px solid var(--border);\r\n}\r\n.community ul.keyword {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n.community ul.keyword > li {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  background: var(--sky);\r\n  padding: 0 12px;\r\n  height: 28px;\r\n  border-radius: 25px;\r\n  justify-content: center;\r\n}\r\n.community ul.keyword span {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  color: var(--primary);\r\n}\r\n/* .community ul.keyword span:hover {\r\n  background: var(--primary);\r\n  color: var(--gray-00);\r\n} */\r\n.community ul.keyword span:before {\r\n  content: '#';\r\n}\r\n.community ul.keyword li .btn-delete {\r\n  display: inline;\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-left: 0;\r\n  background: url('../img/icon_delete_gray20.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.community .write-area .filearea {\r\n  border: 0;\r\n}\r\n.community .write-box .top + .scrollH {\r\n  padding-right: 14px;\r\n  margin-right: -14px;\r\n}\r\n.community .write-box .filearea .top + .scrollH {\r\n  margin-top: 16px;\r\n  height: 132px;\r\n}\r\n.community .write-box .tagarea .top + .scrollH {\r\n  margin-top: 8px;\r\n  height: 104px;\r\n}\r\n.community .shadow-box {\r\n  border-radius: 4px;\r\n  background: var(--gray-00);\r\n  box-shadow: var(--shadow-02);\r\n}\r\n.community .shadow-box > * {\r\n  padding: 16px;\r\n}\r\n.community .write-area .shadow-box + .shadow-box {\r\n  margin-top: 8px;\r\n}\r\n.community .write-area .write-box .editarea,\r\n.community .shadow-box > .editarea {\r\n  border: 0;\r\n  padding: 0;\r\n}\r\n.write-area .editarea .title-wrap {\r\n  border-bottom: 1px solid var(--border);\r\n  padding: 16px 24px;\r\n}\r\n.input__area.label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n.input__area.label .icon-label {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0;\r\n  padding: 0 8px;\r\n  height: 20px;\r\n  background: var(--primary);\r\n}\r\n.input__area.label input[type='text'] {\r\n  flex: 1;\r\n}\r\n.write-area .editarea .title-wrap label {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  font-size: 20px;\r\n  line-height: 1.6;\r\n  color: var(--gray-20);\r\n  font-weight: 400;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n.write-area .editarea .title-wrap label.star:after {\r\n  font-size: 20px;\r\n  margin-left: 1px;\r\n  line-height: 1.3;\r\n  font-weight: 500;\r\n}\r\n.write-area .editarea .title-wrap .input__area input[type='text']:focus + label,\r\n.write-area .editarea .title-wrap .input__area input[type='text']:valid + label,\r\n.write-area .editarea .editbox-wrap input[type='text']:valid + label {\r\n  display: none;\r\n}\r\n.write-area .editarea .title-wrap input[type='text'] {\r\n  height: 100%;\r\n  width: 100%;\r\n  font-size: 20px;\r\n  line-height: 1.6;\r\n  color: var(--secondary);\r\n  font-weight: 700;\r\n  border: 0;\r\n  padding: 0;\r\n}\r\n.write-area .editarea .editbox-wrap {\r\n  height: 624px;\r\n  border: 0;\r\n  border-radius: 0;\r\n}\r\n.write-area .editarea .editbox-wrap .ck.ck-editor {\r\n  height: 100%;\r\n}\r\n.write-area .editarea .editbox-wrap .ck.ck-editor__main {\r\n  height: calc(100% - 30px);\r\n  border-top: 1px solid #dde2e9;\r\n}\r\n.write-area .editarea .editbox-wrap .ck.ck-editor__main .ck.ck-content.ck-editor__editable {\r\n  height: calc(100% - 16px);\r\n  padding: 16px 24px 0;\r\n  border: 0;\r\n  border-radius: 0 0 4px 4px;\r\n}\r\n.area-result .ck.ck-editor__main h2 {\r\n  font-size: 1.5em;\r\n}\r\n.area-result .ck.ck-editor__main h3 {\r\n  font-size: 1.17em;\r\n}\r\n.area-result .ck.ck-editor__main h2,\r\n.area-result .ck.ck-editor__main h3,\r\n.area-result .ck.ck-editor__main h4 {\r\n  font-weight: bold;\r\n  margin: revert;\r\n  padding: revert;\r\n}\r\n.area-result .ck.ck-editor__main h4,\r\n.area-result .ck.ck-editor__main p,\r\n.area-result .ck.ck-editor__main span {\r\n  font-size: 1em;\r\n}\r\n.write-area .editarea .editbox-wrap .ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {\r\n  box-shadow: none;\r\n}\r\n.write-area .editarea .editbox-wrap .ck.ck-toolbar {\r\n  border: 0;\r\n  height: 30px;\r\n}\r\n.write-area .editarea .editbox-wrap .ck.ck-toolbar > .ck-toolbar__items {\r\n  height: 100% !important;\r\n}\r\n.write-area .editarea .editbox-wrap .ck.ck-toolbar.ck-toolbar_vertical > .ck-toolbar__items {\r\n  width: auto;\r\n  max-width: unset;\r\n}\r\n.area-result .ck i {\r\n  display: unset;\r\n\r\n  width: unset;\r\n  height: unset;\r\n}\r\n.area-result .ck dl,\r\n.area-result .ck ol,\r\n.area-result .ck table,\r\n.area-result .ck ul,\r\n.area-result .ck p,\r\n.area-result .ck span {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n.area-result .ck.ck-toolbar.ck-toolbar_vertical > .ck-toolbar__items > .ck {\r\n  width: auto;\r\n}\r\n\r\n@media screen and (max-width: 1278px) {\r\n  .community.detail .solution-area .m-m10 .page-info {\r\n    margin-top: 10px;\r\n  }\r\n}\r\n@media screen and (max-width: 940px) {\r\n  #wrap:not(.no-responsive).page-market.community .write-box .input__direct {\r\n    height: 32px;\r\n  }\r\n}\r\n@media screen and (max-width: 600px) {\r\n  .community .shadow-box > * {\r\n    padding: 16px 20px;\r\n  }\r\n  .community .write-area .flex-row {\r\n    gap: 16px;\r\n    flex-direction: column !important;\r\n  }\r\n  .community .write-area .flex-row > .left .tit {\r\n    margin: 0;\r\n  }\r\n  .community .input__area .select,\r\n  .community .area-result .solution-area .write-area .top .input__area .select {\r\n    height: 38px;\r\n  }\r\n  .community .area-result .solution-area .write-area .top .input__area .select {\r\n    min-width: 100%;\r\n    width: 100%;\r\n  }\r\n  .community .write-area .tagarea {\r\n    height: 210px;\r\n  }\r\n  .community .area-result .solution-area .write-area .top .input__area .searchinput {\r\n    flex: 1;\r\n  }\r\n  #wrap:not(.no-responsive).page-market.community .write-box .input__direct {\r\n    width: 100%;\r\n    height: 40px;\r\n  }\r\n  .community .area-result .solution-area .write-area .searcharea .input__direct input[type='text'] {\r\n    height: 38px;\r\n  }\r\n  .community .area-result .solution-area .write-area .searcharea .btn-add {\r\n    width: 40px;\r\n    height: 40px;\r\n    background-size: 16px;\r\n  }\r\n  .community .write-box .tagarea .top + .scrollH {\r\n    margin-top: 16px;\r\n    height: 134px;\r\n  }\r\n  .community .write-box .filearea .top + .scrollH {\r\n    height: 128px;\r\n  }\r\n  .community .write-area .write-box .filearea .top {\r\n    gap: 8px;\r\n  }\r\n  .community .write-area .write-box > .btn-area button.large {\r\n    height: 40px !important;\r\n  }\r\n}\r\n@media screen and (max-width: 499px) {\r\n  .community .write-area .write-box > .btn-area {\r\n    flex-wrap: nowrap;\r\n  }\r\n  .community .write-area .write-box > .btn-area button.large {\r\n    padding: 0 20px;\r\n  }\r\n  .write-area .editarea .editbox-wrap .ck.ck-editor__main {\r\n    height: calc(100% - 38px) !important;\r\n  }\r\n}\r\n@media screen and (max-width: 360px) {\r\n  .community .write-area .write-box > .btn-area button.large.w140 {\r\n    flex: 1;\r\n    width: auto !important;\r\n  }\r\n}\r\n\r\n/* Community - detail - 마이페이지 */\r\n.community .mypage-area {\r\n  margin-top: -16px;\r\n  min-height: 906px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.community .shadow-box > .mypage-top {\r\n  display: flex;\r\n  gap: 52px;\r\n  padding: 40px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.mypage-top > .left {\r\n  display: flex;\r\n  gap: 16px;\r\n}\r\n.mypage-top .user-photo {\r\n  width: 72px;\r\n  height: 72px;\r\n  position: relative;\r\n}\r\n.mypage-top .user-photo > button.btn-profile {\r\n  border: 0;\r\n  position: relative;\r\n  width: 72px;\r\n  height: 72px;\r\n  border-radius: 50%;\r\n}\r\n.mypage-top .user-photo > button.btn-profile span {\r\n  font-size: 2.5rem;\r\n  color: #fff;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--gray-20);\r\n  border-radius: 50%;\r\n}\r\n.mypage-top .user-photo > button.btn-profile:not(.non-hover):hover::before,\r\n.mypage-top .user-photo > button.btn-profile:not(.non-hover):active::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: url('../img/icon_pen_white.svg') no-repeat center center rgba(10, 120, 255, 0.5);\r\n  background-size: 24px;\r\n  border-radius: 50%;\r\n}\r\n.mypage-top .user-photo > button.btn-profile.non-hover,\r\n.mypage-top .user-photo > button.btn-profile:disabled {\r\n  cursor: default;\r\n  border-color: unset !important;\r\n  background-color: unset !important;\r\n}\r\n.mypage-top .user-photo > button.btn-profile img {\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n.mypage-top .user-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n.mypage-top .user-info > * {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n.mypage-top .user-info p {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n.mypage-top .user-info .name {\r\n  font-size: 16px;\r\n}\r\n.mypage-top > .right {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n.mypage-top > .right .tit {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n}\r\n.mypage-top > .right .txt {\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n}\r\n.mypage-top .btn i {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.community .shadow-box > .mypage-bottom {\r\n  display: flex;\r\n  padding: 0;\r\n  flex: 1;\r\n}\r\n.mypage-bottom > .left {\r\n  width: 205px;\r\n  background: #f7f8fa;\r\n  border-right: 1px solid var(--border);\r\n}\r\n.mypage-bottom > .left .lnb {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.mypage-bottom > .left .lnb > li {\r\n  height: 46px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.mypage-bottom > .left .lnb > li > a {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 100%;\r\n  padding: 0 24px;\r\n  font-size: 14px;\r\n  line-height: 1;\r\n  color: var(--secondary);\r\n}\r\n.mypage-bottom > .left .lnb > li.on {\r\n  border-right: 1px solid var(--white);\r\n  width: calc(100% + 1px);\r\n}\r\n.mypage-bottom > .left .lnb > li.on > a {\r\n  color: var(--primary);\r\n  font-weight: 700;\r\n  background: #fff;\r\n}\r\n.mypage-bottom .lnb__toggleBtn {\r\n  display: none;\r\n}\r\n.mypage-bottom > .right {\r\n  flex: 1;\r\n  padding: 8px 16px 16px;\r\n  width: calc(100% - 237px);\r\n}\r\n.area-result .solution-area .mypage-area .mypage-bottom .tab__line {\r\n  height: 39px;\r\n  margin-bottom: 16px;\r\n}\r\n.area-result .solution-area .mypage-area .mypage-bottom .tab__line li {\r\n  font-size: 15px;\r\n  color: var(--gray-40);\r\n  font-weight: 400;\r\n  padding: 0 14px 0 16px !important;\r\n}\r\n.area-result .solution-area .mypage-area .mypage-bottom .tab__line li .num {\r\n  min-width: 25px;\r\n  margin-left: 4px;\r\n  font-weight: 350;\r\n  text-align: center;\r\n  color: var(--gray-20);\r\n}\r\n.area-result .solution-area .mypage-area .mypage-bottom .tab__line li.on,\r\n.area-result .solution-area .mypage-area .mypage-bottom .tab__line li:hover {\r\n  font-weight: 500;\r\n  color: var(--secondary);\r\n}\r\n.area-result .solution-area .mypage-area .mypage-bottom .tab__line li.on .num,\r\n.area-result .solution-area .mypage-area .mypage-bottom .tab__line li:hover .num {\r\n  color: var(--primary);\r\n}\r\n.area-result .solution-area .mypage-area .mypage-bottom .tab__line li.on:after,\r\n.area-result .solution-area .mypage-area .mypage-bottom .tab__line li:hover:after {\r\n  height: 3px;\r\n}\r\n.mypage-area .mypage-bottom .item-list-top,\r\n.m-m10 .item-list-top,\r\n.community .solution-area .m-m10 .mypage-bottom .item-list-top {\r\n  margin: 0 0 16px;\r\n  width: 100%;\r\n  align-items: center;\r\n}\r\n.community .solution-area .mypage-bottom .item-list-top .left,\r\n.community .solution-area .mypage-bottom .item-list-top .right {\r\n  gap: 8px;\r\n}\r\n.community .solution-area .mypage-bottom .item-list-top .left p {\r\n  font-size: 0.813rem;\r\n  font-weight: 400;\r\n  color: #7783a1;\r\n}\r\n.community .solution-area .mypage-bottom .item-list-top .left p.tit {\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  line-height: 1.25;\r\n  color: var(--secondary);\r\n  margin-top: 8px;\r\n}\r\n.community .solution-area .mypage-bottom .item-list-top .right .btn-basic + .btn-basic {\r\n  margin-left: 0;\r\n}\r\n.community .solution-area .mypage-bottom .item-list-top .right button.small {\r\n  height: 20px !important;\r\n  padding: 0 8px;\r\n  border-radius: 25px;\r\n}\r\n.community .solution-area .mypage-bottom .item-list-top .right button.small span {\r\n  font-size: 12px !important;\r\n  font-weight: 400;\r\n}\r\n.community .solution-area .mypage-bottom .item-list-top .right button.btn i {\r\n  margin-bottom: -4px;\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.list-area > li {\r\n  padding: 12px 0;\r\n  border-top: 1px solid var(--border);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n.list-area > li > .list-top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 5px;\r\n}\r\n.list-area > li > .list-top > .left,\r\n.list-area > li > .list-top > .right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n}\r\n/* .list-area > li > .list-top > .left {\r\n  flex: 1;\r\n  max-width: 80%;\r\n} */\r\n.list-area > li > .list-top > .left {\r\n}\r\n.list-area > li > .list-top > .right {\r\n  justify-content: flex-end;\r\n  width: auto;\r\n  flex: 1;\r\n}\r\n/* .list-area > li > .list-top > .left + .right {\r\n  width: auto;\r\n} */\r\n.list-area > li > .list-top > .left p {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  line-height: 1.4;\r\n  color: var(--secondary);\r\n  width: 100%;\r\n}\r\n.list-area > li > .list-top > .right p {\r\n  color: #7783a1;\r\n  font-size: 0.75rem;\r\n}\r\n.list-area > li > .list-top .btn-alarm {\r\n  position: relative;\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 4px solid #fff;\r\n  background: #0978ff;\r\n  border-radius: 50px;\r\n}\r\n.list-area > li > .list-top .btn-alarm:hover::before {\r\n  content: '읽음으로 표시';\r\n  position: absolute;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  right: 22px;\r\n  width: 85px;\r\n  height: 18px;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  color: #2a2c2f;\r\n  background: #dde2e9;\r\n  border-radius: 10px;\r\n  z-index: 1000;\r\n}\r\n.list-area > li > .list-top .btn-alarm:hover:after {\r\n  content: '';\r\n  position: absolute;\r\n  left: -5px;\r\n  top: -5px;\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50px;\r\n  background: transparent;\r\n  border: 1px solid#0A78FF;\r\n}\r\n.list-area > li > .list-top .btn-alarm.readend {\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 1px solid #515d6f;\r\n  background: transparent;\r\n}\r\n.list-area > li > .list-top .btn-alarm.readend:hover:before {\r\n  content: '안읽음으로 표시';\r\n  width: 108px;\r\n  right: 24px;\r\n}\r\n.list-area > li > .list-top .btn-alarm.readend:hover:after {\r\n  content: none;\r\n}\r\n.list-area > li > .list-bottom {\r\n  border: 1px solid var(--border);\r\n  padding: 12px;\r\n}\r\n.list-area > li > .list-bottom > a {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n}\r\n.list-area > li > .list-bottom > a .top {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 8px;\r\n  margin: 0;\r\n}\r\n.list-area > li > .list-bottom > a .top .cate {\r\n  font-size: 0.625rem;\r\n  font-weight: 500;\r\n  color: #fff;\r\n  padding: 0 8px;\r\n  height: 20px;\r\n  background: var(--gray-20);\r\n  border-radius: 2px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: none;\r\n}\r\n.list-area > li > .list-bottom > a .top .cate.set-blue {\r\n  background: var(--point-01);\r\n}\r\n.list-area > li > .list-bottom > a .top .cate.set-teal {\r\n  background: var(--point-02);\r\n}\r\n.list-area > li > .list-bottom > a .top .cate.set-yellow {\r\n  background: var(--point-03);\r\n}\r\n.list-area > li > .list-bottom > a .top .cate.set-magenta {\r\n  background: var(--point-04);\r\n}\r\n.list-area > li > .list-bottom > a .top .cate.set-navy {\r\n  background: var(--point-05);\r\n}\r\n.list-area > li > .list-bottom > a .top .cate.set-green {\r\n  background: var(--point-06);\r\n}\r\n.list-area > li > .list-bottom > a .top p {\r\n  font-size: 0.813rem;\r\n  font-weight: 400;\r\n  color: var(--secondary);\r\n  line-height: 1.4;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  flex: 1;\r\n}\r\n.list-area > li > .list-bottom > a .bottom {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n.list-area > li > .list-bottom > a .bottom p {\r\n  font-size: 0.813rem;\r\n  line-height: 1.4;\r\n  color: var(--secondary);\r\n  flex: 1;\r\n}\r\n.list-area > li > .list-bottom > a .bottom p.answer {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.list-area > li > .list-bottom > a .bottom p.answer::before {\r\n  content: '';\r\n  display: inline-block;\r\n  vertical-align: bottom;\r\n  margin-right: 4px;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: url('../img/icon_answer_arrow.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.list-area > li > .list-bottom > a .bottom p.answer.others::before {\r\n  background: url('../img/icon_answer_arrow_gray.svg') no-repeat center center;\r\n}\r\n.list-area > li > .list-bottom > a .bottom p.info {\r\n  display: flex;\r\n}\r\n.list-area > li > .list-bottom > a .bottom p.info::before {\r\n  content: '';\r\n  display: inline-block;\r\n  vertical-align: bottom;\r\n  margin-right: 4px;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: url('../img/icon_info.svg') no-repeat center -1px;\r\n  background-size: 100%;\r\n  flex: none;\r\n}\r\n.list-area > li > .list-bottom > a .bottom p.move::before {\r\n  content: '';\r\n  display: inline-block;\r\n  vertical-align: bottom;\r\n  margin-right: 4px;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: url('../img/icon_move.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.list-area > li > .list-bottom > a .bottom strong {\r\n  font-weight: 500;\r\n}\r\n.mypage-bottom .list-area + .txt-info {\r\n  margin: 80px 0 160px 0;\r\n  font-size: 13px;\r\n  color: #8898b7;\r\n  line-height: 1.4;\r\n  text-align: center;\r\n}\r\n\r\n@media screen and (max-width: 1278px) {\r\n  .community .mypage-area {\r\n    margin-top: 0;\r\n  }\r\n}\r\n@media screen and (max-width: 940px) {\r\n  #wrap:not(.no-responsive).page-market.community .write-box .input__direct {\r\n    height: 32px;\r\n  }\r\n  .community .shadow-box > .mypage-top {\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    padding: 32px;\r\n  }\r\n}\r\n@media screen and (max-width: 732px) {\r\n  .community .shadow-box > .mypage-bottom {\r\n    flex-direction: column;\r\n  }\r\n  .mypage-bottom > .left,\r\n  .mypage-bottom > .left .lnb > li.on {\r\n    width: 100%;\r\n    border-right: 0;\r\n  }\r\n  .mypage-bottom > .left {\r\n    position: relative;\r\n  }\r\n  .mypage-bottom > .right {\r\n    padding: 8px 20px;\r\n    width: calc(100% - 40px);\r\n  }\r\n  .mypage-bottom > .left .lnb__toggleBtn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 20px;\r\n    width: calc(100% - 40px);\r\n    height: 47px;\r\n    background: #fff;\r\n    border-bottom: 1px solid #dde2e9;\r\n    cursor: pointer;\r\n  }\r\n  .mypage-bottom > .left:after {\r\n    content: '';\r\n    width: 100%;\r\n    height: 8px;\r\n    position: absolute;\r\n    bottom: -8px;\r\n    left: 0;\r\n    background: linear-gradient(180deg, rgba(144, 159, 183, 0.0001) 10%, rgba(144, 159, 183, 0.2) 100%);\r\n    transform: rotate(-180deg);\r\n  }\r\n  .mypage-bottom > .left .lnb__toggleBtn p {\r\n    color: #2a2c2f;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n  }\r\n  .mypage-bottom > .left .lnb__toggleBtn::after {\r\n    content: '';\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-left: 40px;\r\n    background: url('../img/icon_arrow_secondary.svg') no-repeat center center;\r\n    background-size: 100%;\r\n  }\r\n  .mypage-bottom > .left .lnb__toggleBtn.active::after {\r\n    content: '';\r\n    transform: rotate(180deg);\r\n  }\r\n  .mypage-bottom > .left .lnb {\r\n    display: none;\r\n  }\r\n  .mypage-bottom > .left .lnb.active {\r\n    display: flex;\r\n    position: absolute;\r\n    top: 48px;\r\n    z-index: 2;\r\n    left: 0;\r\n    width: 100%;\r\n    background: #f7f8fa;\r\n    box-shadow: 0px 4px 4px 0px rgba(67, 85, 131, 0.25);\r\n  }\r\n}\r\n@media screen and (max-width: 500px) {\r\n  #wrap:not(.no-responsive).community .solution-area .mypage-bottom .item-list-top .right button.small.btn-basic {\r\n    padding: 0 8px;\r\n  }\r\n}\r\n@media screen and (max-width: 499px) {\r\n  #wrap.page-market.community.detail > .container .content.mypage {\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n    padding: 0 10px;\r\n    width: calc(100% - 20px);\r\n  }\r\n  .community .mypage-area.shadow-box {\r\n    margin-top: 0;\r\n    box-shadow: none;\r\n  }\r\n  .community .shadow-box > .mypage-top {\r\n    padding: 40px 20px 20px;\r\n  }\r\n}\r\n\r\n/* Community - detail - 마이페이지 - 내게시글 */\r\n.mypage-bottom .item-list-area > .item-list-top .left,\r\n.community .solution-area .mypage-bottom .item-list-area > .item-list-top .left {\r\n  gap: 24px;\r\n}\r\n.mypage-bottom .item-list-area > .item-list-top .select {\r\n  border: 0;\r\n  height: auto;\r\n}\r\n.mypage-bottom .item-list-area > .item-list-top .select.active {\r\n  font-weight: 500;\r\n}\r\n.community .area-result .solution-area .mypage-bottom .item-list-area > .item-list-top .select .selected {\r\n  padding: 0;\r\n}\r\n.community .area-result .solution-area .mypage-bottom .item-list-area > .item-list-top .select ul li {\r\n  padding: 16px 24px;\r\n  font-size: 15px;\r\n  width: calc(100% - 48px) !important;\r\n}\r\n.community .area-result .mypage-bottom .item-list-area .item-list > li {\r\n  max-width: 320px;\r\n  height: 306px;\r\n}\r\n\r\n@media screen and (max-width: 1562px) {\r\n  .community .area-result .mypage-area .item-list {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n}\r\n@media screen and (max-width: 1300px) {\r\n  .community .area-result .mypage-area .item-list {\r\n    grid-template-columns: repeat(2, 49.2%);\r\n  }\r\n  .community .area-result .mypage-bottom .item-list-area .item-list > li {\r\n    max-width: 100%;\r\n  }\r\n}\r\n@media screen and (max-width: 940px) {\r\n  .community .area-result .mypage-area .item-list {\r\n    grid-template-columns: repeat(1, 100%);\r\n  }\r\n}\r\n\r\n/* Community - detail - 마이페이지 - 내정보 */\r\n.community .area-result .mypage-bottom .box {\r\n  padding: 24px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  min-height: 426px;\r\n}\r\n.community .area-result .mypage-bottom .box .form__input li {\r\n  gap: 42px;\r\n}\r\n.community .area-result .mypage-bottom .box .form__input label {\r\n  min-width: 94px;\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  font-size: 14px;\r\n  letter-spacing: -0.04em;\r\n}\r\n.community .area-result .mypage-bottom .box .form__input .input__area {\r\n  width: 280px;\r\n}\r\n.community .area-result .mypage-bottom .box .form__input .input__area input[type='text'],\r\n.community .area-result .mypage-bottom .box .form__input .input__area input[type='password'],\r\n.community .area-result .mypage-bottom .box .form__input .input__area input[type='tel'],\r\n.community .area-result .mypage-bottom .box .form__input .input__area input[type='file'] {\r\n  height: 30px;\r\n}\r\n.community .area-result .mypage-bottom .box .form__input button[class*='-txt'] span {\r\n  font-size: 14px;\r\n}\r\n.community .mypage-bottom .banner-box {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 16px;\r\n  min-height: 66px;\r\n  padding: 32px 16px 16px 24px;\r\n  background: url('../img/bg_banner_my.jpg') no-repeat 0 0;\r\n  background-size: cover;\r\n}\r\n.community .mypage-bottom .banner-box::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 16px;\r\n  width: 48px;\r\n  height: 20px;\r\n  background: url('../img/icon_logo_ls_white.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.community .mypage-bottom .banner-box p {\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  font-weight: 400;\r\n  color: var(--secondary);\r\n  letter-spacing: -0.07em;\r\n}\r\n.community .mypage-bottom .banner-box p strong {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #003378;\r\n}\r\n.community .mypage-bottom .banner-box .right {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: flex-end;\r\n  gap: 8px;\r\n}\r\n.community .mypage-bottom .banner-box .right button {\r\n  padding: 0 16px;\r\n  height: 46px;\r\n  border-radius: 25px;\r\n  background: rgba(10, 120, 255, 0.8);\r\n  border-color: rgba(10, 120, 255, 0.8);\r\n}\r\n.community .mypage-bottom .banner-box .right button[class*='-line'] {\r\n  border-color: #fff;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  min-width: 132px;\r\n}\r\n.community .mypage-bottom .banner-box .right button[class*='-line'] span {\r\n  color: #646c74;\r\n  font-size: 15px;\r\n}\r\n@media screen and (max-width: 1240px) {\r\n  .community .mypage-bottom .banner-box {\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    background: url('../img/coverbg_banner_my_m.jpg') no-repeat center center;\r\n    background-size: cover;\r\n  }\r\n}\r\n@media screen and (max-width: 940px) {\r\n  #wrap:not(.no-responsive).community .mypage-bottom .banner-box .right button.btn-basic {\r\n    height: 46px;\r\n  }\r\n  #wrap:not(.no-responsive).community .mypage-bottom .banner-box .right button.btn-basic span {\r\n    font-size: 14px;\r\n  }\r\n  .community .area-result .mypage-bottom .box .form__input li {\r\n    flex-direction: row;\r\n    align-items: unset;\r\n  }\r\n  .community .area-result .mypage-bottom .box {\r\n    min-height: 386px;\r\n  }\r\n}\r\n@media screen and (max-width: 732px) {\r\n  .mypage-area .mypage-bottom .item-list-top,\r\n  .m-m10 .item-list-top,\r\n  .community .solution-area .m-m10 .mypage-bottom .item-list-top {\r\n    margin: 0 0 12px;\r\n  }\r\n  .community .solution-area .mypage-bottom .item-list-top .left p.tit {\r\n    display: none;\r\n  }\r\n}\r\n@media screen and (max-width: 500px) {\r\n  .community .area-result .mypage-bottom .box .form__input li {\r\n    margin-top: 0;\r\n  }\r\n}\r\n@media screen and (max-width: 499px) {\r\n  .community .area-result .mypage-bottom .box .form__input li {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n  .community .area-result .mypage-bottom .box .form__input label {\r\n    min-width: 100%;\r\n    font-size: 15px;\r\n  }\r\n  .community .area-result .mypage-bottom .box .form__input button[class*='-txt'] {\r\n    margin: 10px 0;\r\n  }\r\n  .community .area-result .mypage-bottom .box .form__input button[class*='-txt'] span {\r\n    font-size: 16px;\r\n  }\r\n  .community .area-result .mypage-bottom .box .form__input .input__area {\r\n    width: 100%;\r\n  }\r\n  .community .area-result .mypage-bottom .box .form__input .input__area input[type='text'],\r\n  .community .area-result .mypage-bottom .box .form__input .input__area input[type='password'],\r\n  .community .area-result .mypage-bottom .box .form__input .input__area input[type='tel'],\r\n  .community .area-result .mypage-bottom .box .form__input .input__area input[type='file'] {\r\n    height: 38px;\r\n    font-size: 1rem;\r\n  }\r\n  .community .area-result .mypage-bottom .box .form__input label.txt-transparent {\r\n    display: none;\r\n  }\r\n  .community .mypage-bottom .banner-box .right {\r\n    flex-wrap: wrap;\r\n  }\r\n  .community .mypage-bottom .list-area > li > .list-top {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  .list-area > li > .list-top > .left {\r\n    width: 100%;\r\n  }\r\n  .list-area > li > .list-top > .right {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Community - detail - 마이페이지 - 마켓 플레이스 Like 목록 */\r\n.community .area-result .mypage-bottom .item-list-area .item-list.item-like > li {\r\n  height: 526px;\r\n  background: var(--white);\r\n  border: 1px solid var(--border);\r\n}\r\n.community .area-result .item-list.item-like > li .item-info {\r\n  height: calc(100% - 200px);\r\n  padding: 0;\r\n}\r\n.community .area-result .item-list.item-like > li .item-info-top {\r\n  margin-top: 0;\r\n  height: calc(100% - 80px);\r\n  padding: 16px;\r\n}\r\n.community .area-result .item-list.item-like > li .item-info:hover::before,\r\n.community .area-result .item-list.item-like > li .item-info:active::before {\r\n  content: none;\r\n}\r\n.item-list.item-like li .img-wrap .tit {\r\n  left: 32px;\r\n  z-index: unset;\r\n}\r\n.community .area-result .item-list.item-like > li .etc {\r\n  margin-top: 16px;\r\n  justify-content: flex-start;\r\n}\r\n.item-list.item-like .item-info-top .company {\r\n  margin-top: 4px;\r\n}\r\n.item-list.item-like .item-info-top .cont {\r\n  margin-top: 8px;\r\n}\r\n.area-result .item-list.item-like .item-info-top .tit {\r\n  line-height: 1.7;\r\n  padding: 0;\r\n}\r\n\r\n/* Community - 팝업 - 프로필이미지 수정 */\r\n.community .pop-profile {\r\n  width: 256px;\r\n  position: absolute;\r\n  top: 80px;\r\n  left: 0;\r\n  background: var(--gray-00);\r\n  border-radius: 8px;\r\n  box-shadow: 0px 8px 20px 0px rgba(122, 133, 150, 0.5);\r\n  z-index: 2;\r\n  display: none;\r\n}\r\n.community .pop-profile.open {\r\n  display: block;\r\n}\r\n.community .pop-profile .popup__body {\r\n  padding: 12px;\r\n  width: calc(100% - 24px);\r\n}\r\n.community .pop-profile .img-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n.community .pop-profile .img-list > li {\r\n  width: 72px;\r\n  height: 72px;\r\n  background: #eef1f6;\r\n  border-radius: 50%;\r\n}\r\n.community .pop-profile .img-list > li > a {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  font-size: 10px;\r\n  line-height: 1.6;\r\n  color: var(--gray-20);\r\n  font-weight: 500;\r\n}\r\n.community .pop-profile .img-list > li > a:before {\r\n  content: '';\r\n  width: 24px;\r\n  height: 24px;\r\n  background: url('../img/icon_picture.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.community .pop-profile .img-list > li > a.delete:before {\r\n  background: url('../img/icon_delete.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n\r\n/* Community - 팝업 - 회원등급 안내 */\r\n.rank-info-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-top: 34px;\r\n  margin-bottom: 32px;\r\n}\r\n.rank-info-list > li {\r\n  display: flex;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  color: var(--secondary);\r\n  line-height: 1.4;\r\n  font-weight: 400;\r\n  letter-spacing: -0.04em;\r\n}\r\n.rank-info-list > li strong {\r\n  min-width: 40px;\r\n  font-weight: 500;\r\n  color: var(--primary);\r\n}\r\n\r\n/* Community - 팝업 */\r\n.community .popup-layer.popup-basic {\r\n  width: 320px;\r\n}\r\n.community .popup__body,\r\n.pop-login .popup__body {\r\n  max-height: calc(85vh - 7.5rem);\r\n}\r\n.community .popup__footer button {\r\n  width: auto;\r\n  min-width: 120px;\r\n}\r\n.pop-login .popup__footer button {\r\n  width: auto;\r\n  flex: 1;\r\n  max-width: 120px;\r\n  padding: 0 10px;\r\n}\r\n.community .popup__footer button[class*='w'],\r\n.pop-login .popup__footer button[class*='w'] {\r\n  flex: none;\r\n}\r\n.community .popup__body .form__input .radioBox label,\r\n.pop-login .popup__body .form__input .radioBox label {\r\n  width: auto;\r\n  font-weight: 500;\r\n}\r\n.community .popup__body .form__input .radioBox.col label,\r\n.pop-login .popup__body .form__input .radioBox.col label {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* Community - 로그인 팝업 */\r\n#wrap.page-market .pop-login .popup__body .login-wrap {\r\n  width: auto;\r\n  height: auto;\r\n  min-height: auto;\r\n  padding: 0;\r\n  margin: 26px 4px 32px;\r\n  border-top: 0;\r\n  background: none;\r\n}\r\n#wrap.page-market .pop-login .popup__body .login-wrap > p {\r\n  font-size: 0.938rem;\r\n}\r\n#wrap.page-market .pop-login .login__form {\r\n  width: 100%;\r\n}\r\n#wrap.page-market .pop-login .popup__body .login-wrap .login__form .form__input {\r\n  margin: 32px 0 40px;\r\n}\r\n#wrap.page-market .pop-login .popup__body .login-wrap .login__form .form__input li {\r\n  margin-top: 8px;\r\n}\r\n#wrap.page-market .pop-login .login__form .form__input input[type='text'],\r\n#wrap.page-market .pop-login .login__form .form__input input[type='password'] {\r\n  height: 38px;\r\n  width: calc(100% - 34px);\r\n  font-size: 1rem;\r\n}\r\n#wrap.page-market .pop-login .login__form .form__input input[type='text']::placeholder,\r\n#wrap.page-market .pop-login .login__form .form__input input[type='password']::placeholder {\r\n  font-size: 1rem !important;\r\n}\r\n#wrap.page-market .pop-login .login__form .form__etc button[class*='-txt'] {\r\n  gap: 0;\r\n}\r\n#wrap.page-market .pop-login .btn-login {\r\n  margin: 58px 0 24px;\r\n  width: 100%;\r\n  height: 46px;\r\n}\r\n#wrap.page-market .pop-login .btn-login span {\r\n  color: #fff;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n}\r\n#wrap.page-market .pop-login .join li p {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n#wrap.page-market .pop-login .join li .btn-txt span {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n#wrap.page-market .pop-login .select-lang {\r\n  margin-top: 40px;\r\n  gap: 24px;\r\n}\r\n#wrap.page-market .pop-login .select-lang button {\r\n  margin-left: 0;\r\n  height: 20px !important;\r\n}\r\n#wrap.page-market .pop-login .select-lang button span {\r\n  font-size: 12px;\r\n  color: #909fb7 !important;\r\n}\r\n#wrap.page-market .pop-login .select-lang button:hover span,\r\n#wrap.page-market .pop-login .select-lang button:active span,\r\n#wrap.page-market .pop-login .select-lang button.on span {\r\n  color: #0a78ff !important;\r\n  font-weight: 500;\r\n}\r\n@media screen and (max-width: 940px) {\r\n  .community .popup__body,\r\n  #wrap.page-market .pop-login .popup__body {\r\n    max-height: calc(85vh - 7.5rem);\r\n  }\r\n  #wrap.page-market.community .popup__body .login-wrap .login__form .form__input,\r\n  #wrap.page-market .pop-login .popup__body .login-wrap .login__form .form__input {\r\n    gap: 0;\r\n  }\r\n}\r\n\r\n/* Community - 회원가입 팝업 */\r\n.pop-login.popup-type1 .popup__body {\r\n  padding: 24px 20px 17px;\r\n  width: calc(100% - 40px);\r\n  max-height: calc(68vh - 7.5rem);\r\n}\r\n#wrap.page-market .pop-login.popup-type1 .popup__body .terms {\r\n  height: calc(68vh - 7.5rem);\r\n}\r\n.pop-login.popup-type1 .popup__body .form__input li {\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  margin-top: 16px;\r\n}\r\n.pop-login.popup-type1 .popup__body .form__input li:first-child {\r\n  margin-top: 0;\r\n}\r\n.pop-login.popup-type1 .popup__body .form__input label {\r\n  width: 100%;\r\n  font-size: 15px;\r\n}\r\n.pop-login.popup-type1 .popup__body .form__input label.star:after {\r\n  font-size: 14px;\r\n  vertical-align: top;\r\n}\r\n.community .pop-login.popup-type1 .popup__body .input__area .select {\r\n  width: 100%;\r\n  height: 38px;\r\n}\r\n.community .pop-login input[type='checkbox'] + label,\r\n.pop-login.popup-type1 .popup__body .form__input input[type='checkbox'] + label {\r\n  padding-left: 30px;\r\n  width: auto !important;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  letter-spacing: -0.04em;\r\n}\r\n.community .pop-login input[type='checkbox'] + label:before {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n.community .pop-login input[type='checkbox']:checked + label:after {\r\n  width: 20px;\r\n  height: 20px;\r\n  background-size: auto;\r\n}\r\n.input-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  gap: 2px;\r\n}\r\n.input-info > span,\r\n.input-info > li {\r\n  display: flex;\r\n  gap: 2px;\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n  font-weight: 400;\r\n  color: var(--secondary);\r\n  letter-spacing: -0.04em;\r\n}\r\n.input-info > span::before,\r\n.input-info > li::before {\r\n  content: '*';\r\n}\r\n.input-errortxt + .input-info {\r\n  margin-top: 21px;\r\n}\r\n.pop-login.popup-type1 .popup__body .tab__line {\r\n  margin: -16px -20px 24px;\r\n  width: calc(100% + 40px);\r\n  gap: 0;\r\n}\r\n.pop-login.popup-type1 .popup__body .tab__line li {\r\n  flex: 1;\r\n}\r\n.pop-login.popup-type1 .popup__body .tab__line li.on {\r\n  font-weight: 700;\r\n}\r\n#wrap.page-market .pop-login .popup__body.joinok-h {\r\n  padding: 0 20px 49px;\r\n  width: calc(100% - 40px);\r\n}\r\n#wrap.page-market .pop-login .popup__body.joinok-h .complete-txt button {\r\n  width: 100%;\r\n  height: 46px;\r\n}\r\n.pop-login .popup__body.find-company {\r\n  min-height: calc(68vh - 7.5rem);\r\n}\r\n.pop-login .popup__body.find-idpw {\r\n  min-height: calc(54vh - 7.5rem);\r\n}\r\n.pop-login .popup__body.find-idpw .complete-txt {\r\n  height: calc(54vh - 7.5rem);\r\n  margin-top: 0;\r\n}\r\n.pop-login .popup__body.find-idpw .complete-txt p {\r\n  margin-top: 16px;\r\n  font-weight: 400;\r\n  color: #2a2c2f;\r\n  text-align: center;\r\n  font-size: 15px;\r\n}\r\n.pop-login .popup__body.find-idpw .complete-txt .tit {\r\n  font-size: 15px;\r\n  line-height: 1.4;\r\n  letter-spacing: -0.69px;\r\n}\r\n.pop-login .popup__body.find-idpw .radioBox input[type='radio'] {\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Community - 레이어 팝업박스 */\r\n.pop-layer-box {\r\n  display: none;\r\n  flex-direction: column;\r\n  gap: 0;\r\n  position: absolute;\r\n  border: 1px solid var(--border);\r\n  background: #fff;\r\n  box-shadow: var(--shadow-07);\r\n  border-radius: 10px;\r\n  z-index: 2;\r\n}\r\n.pop-layer-box.show {\r\n  display: flex;\r\n}\r\n.pop-layer-box .pop-head {\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.pop-layer-box .pop-head h1 {\r\n  font-size: 0.75rem;\r\n  font-weight: 400;\r\n  color: var(--secondary);\r\n  line-height: 1.3;\r\n  letter-spacing: -0.02em;\r\n}\r\n.pop-layer-box .pop-bottom {\r\n  padding: 8px 12px;\r\n  border-top: 1px solid var(--border);\r\n}\r\n.pop-layer-box .pop-bottom .txt-info {\r\n  margin: 0;\r\n  font-size: 10px;\r\n  color: var(--secondary);\r\n  line-height: 16px;\r\n}\r\n.pop-layer-box .pop-body {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.pop-layer-box .pop-body p {\r\n  font-size: 0.813rem;\r\n  line-height: 1.4;\r\n  letter-spacing: -0.045em;\r\n  color: var(--secondary);\r\n}\r\n.pop-layer-box .pop-body p strong {\r\n  font-weight: 500;\r\n}\r\n/*임시저장 레이어 팝업박스*/\r\n.pop-layer-box.save {\r\n  top: 24px;\r\n  right: -2px;\r\n  min-height: 200px;\r\n  width: 206px;\r\n}\r\n.pop-layer-box.save .list {\r\n  width: 100%;\r\n  min-height: 116px;\r\n}\r\n.pop-layer-box.save .list > li {\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n.pop-layer-box.save .list > li:first-child {\r\n  border-bottom: 1px solid var(--border) !important;\r\n}\r\n.pop-layer-box.save .list > li:last-child {\r\n  border-bottom: 0;\r\n}\r\n.pop-layer-box.save .list > li > a {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  padding: 10px 24px;\r\n}\r\n.pop-layer-box.save .list > li .tit {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  font-size: 0.813rem;\r\n  font-weight: 500;\r\n  line-height: 1.4;\r\n}\r\n.pop-layer-box.save .list > li .date {\r\n  font-size: 0.625rem;\r\n  line-height: 1.6;\r\n  color: var(--gray-40);\r\n}\r\n.pop-layer-box.save .list > li > a:hover {\r\n  background: var(--input-hover);\r\n}\r\n.pop-layer-box.save .list > li > a:hover .tit {\r\n  color: var(--primary);\r\n}\r\n\r\n/*메인 좌우플로팅박스 안내 레이어 팝업박스*/\r\n.pop-layer-box.info {\r\n  width: 320px;\r\n  left: 152px;\r\n  top: 38px;\r\n}\r\n.pop-layer-box.info .pop-body {\r\n  display: block;\r\n  padding: 10px 24px 20px;\r\n}\r\n.pop-layer-box.info.tag {\r\n  right: 20px;\r\n  left: unset;\r\n}\r\n.pop-layer-box.info.tag .pop-body {\r\n  min-height: 62px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n.pop-layer-box.info .list-item {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n.pop-layer-box.info .list-item li {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n.pop-layer-box.info .list-item li i {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n/* Community - 팝업 - 메인 공지사항 */\r\n.popup-layer-news {\r\n  position: fixed;\r\n  left: 100px;\r\n  top: 101px;\r\n  width: 320px;\r\n  background: #fff;\r\n  box-shadow: 0px 10px 30px 0px rgba(42, 44, 47, 0.5);\r\n  z-index: 1000;\r\n}\r\n.popup-layer-news.center {\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.popup-layer-news .popup__head {\r\n  padding: 12px 16px;\r\n  width: calc(100% - 32px);\r\n  justify-content: flex-end;\r\n  border: 0;\r\n}\r\n.popup-layer-news .popup__head .btn-close {\r\n  width: 24px;\r\n  height: 24px;\r\n  background-size: 14px;\r\n}\r\n.popup-layer-news .popup__body {\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n.popup-layer-news .popup__body h1 {\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  font-weight: 700;\r\n  color: var(--secondary);\r\n  padding: 0 16px 8px;\r\n}\r\n.popup-layer-news .popup__body > a {\r\n  width: 100%;\r\n}\r\n.popup-layer-news .popup__body > a > img {\r\n  width: 100%;\r\n}\r\n.popup-layer-news .filelist,\r\n.community .popup-layer-news .filelist {\r\n  margin: 8px 16px 0 40px;\r\n}\r\n.popup-layer-news .filelist li,\r\n.community .popup-layer-news .filelist li {\r\n  margin-bottom: 4px;\r\n  display: block;\r\n}\r\n.popup-layer-news .popup__footer {\r\n  border: 0;\r\n}\r\n.popup-layer-news .popup__footer input[type='checkbox'] + label {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 1.6;\r\n  letter-spacing: -0.04em;\r\n}\r\n.popup-layer-news .popup__footer input[type='checkbox'] + label:before,\r\n.popup-layer-news .popup__footer input[type='checkbox']:checked + label:after {\r\n  top: 4px;\r\n}\r\n.popup-layer-news .popup__footer input[type='checkbox']:checked + label:after {\r\n  background-size: 87%;\r\n}\r\n\r\n/* Community - 라디오박스 */\r\n.community .radioBox.col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 28px;\r\n}\r\n.community .radioBox.col > li {\r\n  margin-top: 0;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n.community .form__input input[type='text'],\r\n.community .form__input input[type='password'],\r\n.community .form__input input[type='tel'],\r\n.community .form__input input[type='file'] {\r\n  height: 38px;\r\n}\r\n.community .popup__body p.input-errortxt {\r\n  top: 2.65rem;\r\n  font-size: 0.75rem;\r\n}\r\n.community .input__area .select,\r\n.community .area-result .solution-area .write-area .top .select {\r\n  width: auto;\r\n  height: 1.875rem;\r\n  border: 1px solid var(--gray-20);\r\n}\r\n.community .input__area .select.active,\r\n.community .area-result .solution-area .write-area .top .select.active {\r\n  border-color: #0d78ff;\r\n}\r\n.community .area-result .solution-area .write-area .top .select {\r\n  min-width: 280px;\r\n}\r\n.community .input__area .select .selected,\r\n.community .area-result .solution-area .write-area .top .select .selected {\r\n  padding: 0 12px;\r\n}\r\n.community .area-result .solution-area .write-area .top .select .selected .arrow {\r\n  width: 20px;\r\n  height: 20px;\r\n  background: url('../img/icon_arrow_bg.svg') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.community .area-result .solution-area .write-area .top .select.active ul {\r\n  display: initial;\r\n  border-color: #0d78ff;\r\n  border-radius: 0 0 4px 4px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  max-height: 200px;\r\n  width: 100% !important;\r\n  max-width: 100% !important;\r\n  margin-top: -0.5px;\r\n  box-shadow: none;\r\n}\r\n.community .area-result .solution-area .write-area .top .select ul li {\r\n  width: calc(100% - 1.5rem) !important;\r\n  padding: 0.563rem 0.75rem !important;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n  font-weight: inherit;\r\n}\r\n\r\n/* 이메일 인증 완료 */\r\n.community .webmailok {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  min-height: calc(100vh - 62px);\r\n}\r\n.community .webmailok .login__form {\r\n  margin-top: -63px;\r\n}\r\n.community .webmailok .login__form .login__info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 22px;\r\n  text-align: center;\r\n  color: #2a2c2f;\r\n}\r\n.community .webmailok .login__form .login__info::before {\r\n  content: '';\r\n  margin: 0 auto 16px;\r\n  width: 100px;\r\n  height: 100px;\r\n  background: url('../img/bg_loginok.png') no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n#wrap.page-market.community .webmailok .btn-login {\r\n  margin: 40px auto 0;\r\n  width: 310px;\r\n}\r\n#wrap.page-market.community .webmailok .btn-login span {\r\n  font-weight: 700;\r\n}\r\n\r\n@media screen and (max-width: 1278px) {\r\n  .community .webmailok {\r\n    min-height: calc(100vh - 102px);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
